! function(e) {
    var t = {};

    function i(o) {
        if (t[o]) return t[o].exports;
        var n = t[o] = {
            i: o,
            l: !1,
            exports: {}
        };
        return e[o].call(n.exports, n, n.exports, i), n.l = !0, n.exports
    }
    i.m = e, i.c = t, i.d = function(e, t, o) {
        i.o(e, t) || Object.defineProperty(e, t, {
            enumerable: !0,
            get: o
        })
    }, i.r = function(e) {
        "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
            value: "Module"
        }), Object.defineProperty(e, "__esModule", {
            value: !0
        })
    }, i.t = function(e, t) {
        if (1 & t && (e = i(e)), 8 & t) return e;
        if (4 & t && "object" == typeof e && e && e.__esModule) return e;
        var o = Object.create(null);
        if (i.r(o), Object.defineProperty(o, "default", {
                enumerable: !0,
                value: e
            }), 2 & t && "string" != typeof e)
            for (var n in e) i.d(o, n, function(t) {
                return e[t]
            }.bind(null, n));
        return o
    }, i.n = function(e) {
        var t = e && e.__esModule ? function() {
            return e.default
        } : function() {
            return e
        };
        return i.d(t, "a", t), t
    }, i.o = function(e, t) {
        return Object.prototype.hasOwnProperty.call(e, t)
    }, i.p = "", i(i.s = 3)
}([function(e, t, i) {
    "use strict";

    function o(e, t) {
        for (var i = 0; i < t.length; i++) {
            var o = t[i];
            o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o)
        }
    }

    function n(e, t, i) {
        return (e.x - i.x) * (t.y - i.y) - (t.x - i.x) * (e.y - i.y)
    }
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.default = function(e, t, i) {
        "string" == typeof e && (i = t, t = e, e = document);
        i || (t = (i = t).selector);
        var o = i,
            n = o.onHover,
            a = void 0 === n ? function() {} : n,
            l = o.onLeave,
            c = void 0 === l ? function() {} : l,
            d = o.attr,
            u = void 0 === d ? "garminTarget" : d,
            p = o.mouseMoveThreshold,
            h = void 0 === p ? 150 : p,
            f = o.idleThreshold,
            m = void 0 === f ? 1500 : f,
            g = o.scrollThreshold,
            v = void 0 === g ? window.screen.height / 10 : g,
            y = o.forceLeaveEventHook,
            w = void 0 === y ? "garminLeave" : y,
            $ = o.findTarget,
            _ = void 0 === $ ? function(e) {
                return document.getElementById(e)
            } : $,
            b = !1,
            S = null;

        function k(e) {
            var i = e.target;
            if (t ? i.matches(t) : i === e.currentTarget)
                if (b) {
                    S = e;
                    i.addEventListener("mouseleave", function e() {
                        S = null, i.removeEventListener("mouseleave", e)
                    })
                } else {
                    var o = _(i.dataset[u], i);
                    if (o) {
                        var n = function(e) {
                                g || (c(e, o, i), e.defaultPrevented || (g = !0))
                            },
                            l = function() {
                                Math.abs(window.pageYOffset - y) < v || window.dispatchEvent(new CustomEvent(w))
                            },
                            d = function e(t) {
                                n(t), t.defaultPrevented || (S = null, window.removeEventListener(w, e), window.removeEventListener("scroll", l))
                            };
                        b = !0;
                        var p, f = !1,
                            g = !1,
                            y = window.pageYOffset;
                        if (a(e, o, i), e.defaultPrevented) return;
                        window.addEventListener(w, d);
                        i.addEventListener("mouseleave", function t() {
                            i.removeEventListener("mouseleave", t);
                            var a = function e() {
                                    f = !0, b = !1, document.removeEventListener("mousemove", u), o.removeEventListener("mouseenter", e)
                                },
                                l = function e(t) {
                                    n(t), t.defaultPrevented || (S && (S.target.dispatchEvent(S), S = null), document.removeEventListener("mousemove", u), o.removeEventListener("mouseenter", a), o.removeEventListener("mouseleave", e), window.removeEventListener(w, d), window.removeEventListener(w, g))
                                };
                            o.addEventListener("mouseenter", a), o.addEventListener("mouseleave", l);
                            var c = r(o, s(e)),
                                u = function(e, t) {
                                    var i, o, n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : null;
                                    return function() {
                                        for (var a = arguments.length, r = new Array(a), s = 0; s < a; s++) r[s] = arguments[s];
                                        var l = Date.now();
                                        i && l < i + t ? (clearTimeout(o), o = setTimeout(function() {
                                            i = l, e.apply(n, r)
                                        }, t)) : (i = l, e.apply(n, r))
                                    }
                                }(function(e) {
                                    function t() {
                                        f || (b = !1, n(e), S && !e.defaultPrevented && (S.target.dispatchEvent(S), S = null), e.defaultPrevented || (document.removeEventListener("mousemove", u), o.removeEventListener("mouseenter", a), window.removeEventListener(w, d), window.removeEventListener(w, g)))
                                    }
                                    y = window.pageYOffset, clearTimeout(p), p = setTimeout(t, m);
                                    var i = s(e);
                                    !f && c.contains(i) ? c = r(o, i) : t()
                                }, h);

                            function g(e) {
                                n(e), e.defaultPrevented || (document.removeEventListener("mousemove", u), o.removeEventListener("mouseenter", a), o.removeEventListener("mouseleave", l), window.removeEventListener(w, g))
                            }
                            document.addEventListener("mousemove", u), window.addEventListener(w, g)
                        }), window.addEventListener("scroll", l)
                    }
                }
        }

        function C(e) {
            var t = setTimeout(k.bind(null, e), 120);
            e.target.addEventListener("mouseleave", function i() {
                clearTimeout(t);
                e.target.removeEventListener("mouseleave", i)
            })
        }

        function x(e) {
            e.addEventListener("mouseover", C)
        }

        function F(e) {
            e.removeEventListener("mouseover", C)
        }
        Array.isArray(e) || e instanceof window.NodeList ? e.forEach(x) : x(e);
        return {
            destroy: function() {
                Array.isArray(e) || e instanceof window.NodeList ? e.forEach(F) : F(e)
            }
        }
    };
    var a = function() {
        function e(t, i, o) {
            ! function(e, t) {
                if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function")
            }(this, e), this.p1 = t, this.p2 = i, this.p3 = o
        }
        return function(e, t, i) {
            t && o(e.prototype, t), i && o(e, i)
        }(e, [{
            key: "contains",
            value: function(e) {
                var t = n(e, this.p1, this.p2) <= 0,
                    i = n(e, this.p2, this.p3) <= 0,
                    o = n(e, this.p3, this.p1) <= 0;
                return t === i && i === o
            }
        }]), e
    }();

    function r(e, t) {
        var i = e.getBoundingClientRect(),
            o = i.x,
            n = i.y,
            r = i.right,
            s = i.bottom,
            l = {},
            c = {};
        return t.x >= o && t.y <= n ? (l.x = o, l.y = n) : t.x >= r && t.y >= n ? (l.x = r, l.y = n) : t.x <= r && t.y >= s ? (l.x = r, l.y = s) : (l.x = o, l.y = s), t.x <= r && t.y <= n ? (c.x = r, c.y = n) : t.x >= r && t.y <= s ? (c.x = r, c.y = s) : t.x >= o && t.y >= s ? (c.x = o, c.y = s) : (c.x = o, c.y = n), new a(t, l, c)
    }

    function s(e) {
        return {
            x: e.clientX,
            y: e.clientY
        }
    }
}, function(e, t, i) {
    "use strict";
    /*! npm.im/object-fit-images 3.2.3 */
    var o = "bfred-it:object-fit-images",
        n = /(object-fit|object-position)\s*:\s*([-\w\s%]+)/g,
        a = "undefined" == typeof Image ? {
            style: {
                "object-position": 1
            }
        } : new Image,
        r = "object-fit" in a.style,
        s = "object-position" in a.style,
        l = "background-size" in a.style,
        c = "string" == typeof a.currentSrc,
        d = a.getAttribute,
        u = a.setAttribute,
        p = !1;

    function h(e, t, i) {
        var o = function(e, t) {
            return "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='" + e + "' height='" + t + "'%3E%3C/svg%3E"
        }(t || 1, i || 0);
        d.call(e, "src") !== o && u.call(e, "src", o)
    }

    function f(e, t) {
        e.naturalWidth ? t(e) : setTimeout(f, 100, e, t)
    }

    function m(e) {
        var t = function(e) {
                for (var t, i = getComputedStyle(e).fontFamily, o = {}; null !== (t = n.exec(i));) o[t[1]] = t[2];
                return o
            }(e),
            i = e[o];
        if (t["object-fit"] = t["object-fit"] || "fill", !i.img) {
            if ("fill" === t["object-fit"]) return;
            if (!i.skipTest && r && !t["object-position"]) return
        }
        if (!i.img) {
            i.img = new Image(e.width, e.height), i.img.srcset = d.call(e, "data-ofi-srcset") || e.srcset, i.img.src = d.call(e, "data-ofi-src") || e.src, u.call(e, "data-ofi-src", e.src), e.srcset && u.call(e, "data-ofi-srcset", e.srcset), h(e, e.naturalWidth || e.width, e.naturalHeight || e.height), e.srcset && (e.srcset = "");
            try {
                ! function(e) {
                    var t = {
                        get: function(t) {
                            return e[o].img[t || "src"]
                        },
                        set: function(t, i) {
                            return e[o].img[i || "src"] = t, u.call(e, "data-ofi-" + i, t), m(e), t
                        }
                    };
                    Object.defineProperty(e, "src", t), Object.defineProperty(e, "currentSrc", {
                        get: function() {
                            return t.get("currentSrc")
                        }
                    }), Object.defineProperty(e, "srcset", {
                        get: function() {
                            return t.get("srcset")
                        },
                        set: function(e) {
                            return t.set(e, "srcset")
                        }
                    })
                }(e)
            } catch (e) {
                window.console && console.warn("https://bit.ly/ofi-old-browser")
            }
        }! function(e) {
            if (e.srcset && !c && window.picturefill) {
                var t = window.picturefill._;
                e[t.ns] && e[t.ns].evaled || t.fillImg(e, {
                    reselect: !0
                }), e[t.ns].curSrc || (e[t.ns].supported = !1, t.fillImg(e, {
                    reselect: !0
                })), e.currentSrc = e[t.ns].curSrc || e.src
            }
        }(i.img), e.style.backgroundImage = 'url("' + (i.img.currentSrc || i.img.src).replace(/"/g, '\\"') + '")', e.style.backgroundPosition = t["object-position"] || "center", e.style.backgroundRepeat = "no-repeat", e.style.backgroundOrigin = "content-box", /scale-down/.test(t["object-fit"]) ? f(i.img, function() {
            i.img.naturalWidth > e.width || i.img.naturalHeight > e.height ? e.style.backgroundSize = "contain" : e.style.backgroundSize = "auto"
        }) : e.style.backgroundSize = t["object-fit"].replace("none", "auto").replace("fill", "100% 100%"), f(i.img, function(t) {
            h(e, t.naturalWidth, t.naturalHeight)
        })
    }

    function g(e, t) {
        var i = !p && !e;
        if (t = t || {}, e = e || "img", s && !t.skipTest || !l) return !1;
        "img" === e ? e = document.getElementsByTagName("img") : "string" == typeof e ? e = document.querySelectorAll(e) : "length" in e || (e = [e]);
        for (var n = 0; n < e.length; n++) e[n][o] = e[n][o] || {
            skipTest: t.skipTest
        }, m(e[n]);
        i && (document.body.addEventListener("load", function(e) {
            "IMG" === e.target.tagName && g(e.target, {
                skipTest: t.skipTest
            })
        }, !0), p = !0, e = "img"), t.watchMQ && window.addEventListener("resize", g.bind(null, e, {
            skipTest: t.skipTest
        }))
    }
    g.supportsObjectFit = r, g.supportsObjectPosition = s,
        function() {
            function e(e, t) {
                return e[o] && e[o].img && ("src" === t || "srcset" === t) ? e[o].img : e
            }
            s || (HTMLImageElement.prototype.getAttribute = function(t) {
                return d.call(e(this, t), t)
            }, HTMLImageElement.prototype.setAttribute = function(t, i) {
                return u.call(e(this, t), t, String(i))
            })
        }(), e.exports = g
}, function(module, exports, __webpack_require__) {
    "use strict";
    var _objectFitImages = _interopRequireDefault(__webpack_require__(1)),
        _garmin = _interopRequireDefault(__webpack_require__(0));

    function _interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        }
    }

    function _typeof(e) {
        return (_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
            return typeof e
        } : function(e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
        })(e)
    }
    $(_objectFitImages.default), (0, _garmin.default)("[data-mega-menu-target]", {
        attr: "megaMenuTarget",
        onHover: function(e, t, i) {
            $(i).addClass("active_link"), $(t).show()
        },
        onLeave: function(e, t, i) {
            $(i).removeClass("active_link"), $(t).hide()
        },
        findTarget: function(e, t) {
            return t.closest("header").querySelector(e)
        }
    });
    var Shopify = window.Shopify || {};
    document.querySelectorAll(".Form-group").forEach(function(e) {
      	if (e.querySelector("input")) {
            e.querySelector("input").addEventListener("input", function(t) {
                e.classList["" === t.target.value ? "remove" : "add"]("is-filled")
            })
        }
        }),




        
        function() {
            document.querySelectorAll("[data-rough-edge]").forEach(function(e, t) {
                var i = "svg_displacementFilter-" + t;
                e.querySelector("filter").id = i, e.querySelector("feTurbulence").setAttribute("seed", Math.round(1e3 * Math.random())), e.querySelectorAll("path").forEach(function(e) {
                    e.setAttribute("d", function(e, t, i) {
                        for (t = "M0 0", i = 0, e = 100 / e; i <= 100;) t += "L" + i + " " + Math.round(2e3 * Math.random()) / 1e3, i += e;
                        return t + "V50H0Z"
                    }(1240)), e.style.filter = "url(#" + i + ")"
                })
            })
        }();
    var usePageDots = BUFFALO.slideshow_nav_buttons,
        imageFunctions = {
            zoom: function(e, t, i) {
                $(e).data("zoom") && $(e + " img").wrap('<span style="display:inline-block"></span>').css("display", "block").parent().zoom({
                    touch: t,
                    magnify: i || 1
                })
            },
            linkGalleryAndCarousel: function(e, t) {
                t.find(".gallery-cell:nth-child(1)").addClass("is-nav-selected"), t.on("click", ".gallery-cell", function() {
                    var i = $(this).index();
                    t.find(".is-nav-selected").removeClass("is-nav-selected"), $(this).addClass("is-nav-selected"), e.flickity("select", i)
                }), e.on("cellSelect", function() {
                    var e = $(this).data("flickity");
                    e && (t.find(".is-nav-selected").removeClass("is-nav-selected"), t.find(".gallery-cell:nth-child(" + (e.selectedIndex + 1) + ")").addClass("is-nav-selected"))
                })
            },
            fullWidth: function(e, t) {
                $(e).each(function() {
                    var e = $(this),
                        i = e.attr("alt"),
                        o = e.attr("src");
                    if (i.indexOf("[") >= 0) {
                        e.remove();
                        var n = i.match(/\[(.*?)\]/gi);
                        i = i.replace(/\[(.*?)\]/gi, "");
                        var a = $.map(n, function(e, t) {
                                return e = e.replace(/[\[\]']+/g, "")
                            }),
                            r = ['<div class="position-' + (a.length ? a : "center") + ' caption js-caption">', '<div class="caption-content caption-background-false align-' + (a.length ? a : "center") + '">', '<p class="headline">' + i + "</p>", "</div>", "</div>"].join("");
                        e.attr({
                            alt: i,
                            class: "lazyload " + BUFFALO.image_loading_style,
                            src: o,
                            dataSizes: "auto"
                        });
                        var s = '<div class="banner">' + e.prop("outerHTML") + r + "</div>";
                        $(t).append(s)
                    }
                })
            },
            showSecondaryImage: function() {
                $("body").on("mouseenter", ".swap-true", function() {
                    $(this).toggleClass("toggle-images")
                }), $("body").on("mouseleave", ".swap-true", function() {
                    $(this).toggleClass("toggle-images")
                })
            }
        },
        recentlyViewed = {
            init: function() {
                var e, t, i, o, n;
                if ($(".js-product_section[data-rv-handle]").length ? (e = $(".js-product_section").data("rv-handle").toString(), t = Cookies.get("recentlyViewed"), i = recentlyViewed.getCookieProducts(t, e)) : $(".recently-viewed__section").length ? (t = Cookies.get("recentlyViewed"), i = recentlyViewed.getCookieProducts(t, e)) : $(".collection-template-section .js-sidebar-recently-viewed").length && (t = Cookies.get("recentlyViewed"), i = recentlyViewed.getCookieProducts(t, e)), i && (n = unescape(i).split(",")), e ? (-1 !== !$.inArray(e, n) && (o = [], n.unshift(e), $.each(n, function(e, t) {
                        -1 === $.inArray(t, o) && o.push(t)
                    })), recentlyViewed.setCookieProducts(o)) : o = n, $(".recently-viewed__section").length) {
                    var a = ".recently-viewed__section";
                    recentlyViewed.getProductInformation(a, o)
                } else if ($(".js-recently-viewed .rv-main").length) {
                    a = ".js-recently-viewed";
                    recentlyViewed.getProductInformation(a, o, e)
                }
                if ($(".sidebar .js-sidebar-recently-viewed").length) {
                    a = ".sidebar .js-sidebar-recently-viewed";
                    e ? recentlyViewed.getProductInformation(a, o, e) : recentlyViewed.getProductInformation(a, o), $(".js-sidebar-recently-viewed.hidden").parents(".sidebar-block").hide()
                }
            },
            getCookieProducts: function(e, t) {
                return !e && t ? (Cookies.set("recentlyViewed", t, {
                    expires: 30,
                    path: "/"
                }), e = Cookies.get("recentlyViewed")) : e = Cookies.get("recentlyViewed"), e
            },
            setCookieProducts: function(e) {
                Cookies.set("recentlyViewed", escape(e.join(",")), {
                    expires: 30,
                    path: "/"
                })
            },
            getProductInformation: function(e, t, i) {
                i && t.splice($.inArray(i, t), 1);
                var o = $(e).data("visible-products");
                o && t && (t = t.slice(0, o)), $.each(t, function(i, n) {
                    n && ($(e).removeClass("hidden"), $(e).parents(".sidebar-block").show(), $.ajax({
                        type: "GET",
                        url: "/products/" + n + "?view=rv",
                        success: function(t) {
                            var o = $(t).find(".js-recently-viewed-product");
                            $(e).find(" .rv-box-" + i).append(o), BUFFALO.show_multiple_currencies && convertCurrencies()
                        },
                        error: function(e, t, i) {
                            console.log(e), console.log(t), console.log(i)
                        },
                        dataType: "html"
                    })), $(e).find(".rv-main").hasClass("js-rv-slider") ? (t.length <= o ? $(".js-rv-slider .gallery-cell").eq(t.length).nextAll().addBack().remove() : $(".js-rv-slider .gallery-cell").eq(o).nextAll().addBack().remove(), recentlyViewed.createSlider(e, o)) : $(e).find(".rv-main").hasClass("js-rv-grid") && (t.length <= o ? $(".js-rv-grid .thumbnail").eq(t.length).nextAll().addBack().remove() : $(".js-rv-grid .thumbnail").eq(o).nextAll().addBack().remove())
                })
            },
            createSlider: function(e, t) {
                var i, o, n, a, r, s = $(".js-rv-slider").data("products-per-slide"),
                    l = $(".js-rv-slider").data("products-limit"),
                    c = t,
                    d = $(".js-rv-slider").find(".gallery-cell");
                i = "2" == s && c > s && l > s || "4" == s && c > s && l > s || "6" == s && c > s && l > s ? "left" : "center", c > s && l > s ? (o = !0, n = !0, a = !0) : (o = !1, n = !1, a = !1), "2" == s && c > s || "4" == s && c > s || "6" == s && c > s ? r = 0 : "3" == s && c ? r = 1 : "5" == s && c ? r = 2 : "7" == s && c && (r = 3), $(window).width() <= 798 && (i = "center", r = 1, d.length <= 2 ? (o = !1, n = !1, a = !1) : c > 3 && l > 3 ? (o = !0, n = !0, a = !0) : (o = !1, n = !1, a = !1), $(".js-rv-slider").parents(".even-num-slides").removeClass("even-num-slides")), $(".js-rv-slider").flickity({
                    lazyLoad: 2,
                    imagesLoaded: !0,
                    draggable: o,
                    prevNextButtons: n,
                    wrapAround: a,
                    cellAlign: i,
                    pageDots: usePageDots,
                    contain: !0,
                    freeScroll: !0,
                    arrowShape: arrowSize,
                    initialIndex: r
                }), $(".js-rv-slider").addClass("slider-initialized")
            }
        },
        featuredCollectionSection = {
            init: function() {
                $(".js-product-slider .products-slider").each(function(e, t) {
                    var i, o, n, a, r, s = $(this).data("products-per-slide"),
                        l = $(this).data("products-limit"),
                        c = $(this).data("products-available");
                    i = "2" == s && c > s && l > s || "4" == s && c > s && l > s || "6" == s && c > s && l > s ? "left" : "center", c > s && l > s ? (o = !0, n = !0, a = !0) : (o = !1, n = !1, a = !1), "2" == s && c > s || "4" == s && c > s || "6" == s && c > s ? r = 0 : "3" == s && c ? r = 1 : "5" == s && c ? r = 2 : "7" == s && c && (r = 3), $(window).width() <= 798 && (i = "center", o = !0, n = !0, a = !0, r = 1, $(this).parents(".even-num-slides").removeClass("even-num-slides")), $(this).flickity({
                        lazyLoad: 2,
                        imagesLoaded: !0,
                        draggable: o,
                        prevNextButtons: n,
                        wrapAround: a,
                        cellAlign: i,
                        pageDots: usePageDots,
                        contain: !0,
                        freeScroll: !0,
                        arrowShape: arrowSize,
                        initialIndex: r
                    }), $(this).addClass("slider-initialized")
                })
            },
            unload: function(e) {
                var t = e.find(".js-product-slider");
                t.hasClass("flickity-enabled") && t.flickity("destroy")
            }
        },
        featuredPromotions = {
            init: function() {
                ($(window).width() > 798 || 0 == $(window).width()) && $(".js-featured-promotions").each(function(e, t) {
                    var i = $(this),
                        o = $(this).data("promo-animation");
                    i.waypoint(function() {
                        $(this.element).find(".feature-section").addClass("animated " + o)
                    }, {
                        offset: "80%"
                    })
                })
            }
        };
    document.querySelectorAll(".button-outer").forEach(function(e) {
        var t = e.querySelector(".button-text");
        t.style.width = e.style.width = t.clientWidth + 2 + "px", e.classList.add("js-ready")
    });
    var slideshow = {
            init: function() {
                $(".js-homepage-slideshow").each(function(e, t) {
                    var i = $(this),
                        o = {
                            slideshowSpeed: 1e3 * i.data("slideshow-speed"),
                            slideshowTextAnimation: i.data("slideshow-text-animation")
                        };
                    if (!i.hasClass("flickity-enabled")) {
                        var n = 1 !== i.find(".gallery-cell").length;
                        if (i.flickity({
                                wrapAround: !0,
                                cellAlign: "left",
                                imagesLoaded: !0,
                                prevNextButtons: n,
                                draggable: n,
                                pageDots: usePageDots,
                                autoPlay: o.slideshowSpeed,
                                arrowShape: arrowSize
                            }), "" != o.slideshowTextAnimation) {
                            var a = i.data("flickity");
                            setTimeout(function() {
                                i.find(".gallery-cell:nth-child(1) .caption-content").addClass("animated " + o.slideshowTextAnimation)
                            }, 400), i.on("cellSelect", function() {
                                if (i.is(":visible")) {
                                    var e = a.selectedIndex + 1;
                                    setTimeout(function() {
                                        i.find(".caption-content").removeClass("animated " + o.slideshowTextAnimation), i.find(".gallery-cell:nth-child(" + e + ") .caption-content").addClass("animated " + o.slideshowTextAnimation)
                                    }, 400)
                                }
                            })
                        }
                    }
                    i.find(".gallery-cell").length > 1 ? i.addClass("multi-image") : i.addClass("single-image"), i.find(".gallery-cell").each(function() {
                        var e = 0;
                        $(this).find(".action_button").each(function() {
                            $(this).width() > e && (e = $(this).width())
                        }), $(this).find(".action_button").width(e)
                    })
                })
            },
            unload: function(e) {
                e.find(".js-homepage-slideshow").flickity("destroy")
            }
        },
        testimonial = {
            init: function() {
                $(".js-testimonial").each(function(e, t) {
                    var i = $(this),
                        o = {
                            slideshowSpeed: 1e3 * i.data("slideshow-speed"),
                            slideshowTextAnimation: i.data("slideshow-text-animation")
                        };
                    if ($(".testimonial-image").length > 0 && $(".testimonial-block").each(function() {
                            if (0 == $(this).find(".testimonial-image").length) {
                                var e = $(this).closest(".testimonial-block");
                                $(e).addClass("set-testimonial-height")
                            }
                        }), !i.hasClass("flickity-enabled")) {
                        var n = 1 !== i.find(".gallery-cell").length;
                        if (i.flickity({
                                wrapAround: !0,
                                cellAlign: "left",
                                imagesLoaded: !0,
                                prevNextButtons: n,
                                draggable: n,
                                pageDots: usePageDots,
                                autoPlay: o.slideshowSpeed,
                                arrowShape: arrowSize
                            }), "" != o.slideshowTextAnimation) {
                            var a = i.data("flickity");
                            setTimeout(function() {
                                i.find(".gallery-cell:nth-child(1) .caption-content").addClass("animated " + o.slideshowTextAnimation)
                            }, 400), i.on("cellSelect", function() {
                                if (i.is(":visible")) {
                                    var e = a.selectedIndex + 1;
                                    setTimeout(function() {
                                        i.find(".caption-content").removeClass("animated " + o.slideshowTextAnimation), i.find(".gallery-cell:nth-child(" + e + ") .caption-content").addClass("animated " + o.slideshowTextAnimation)
                                    }, 400)
                                }
                            })
                        }
                    }
                    i.find(".gallery-cell").length > 1 ? i.addClass("multi-image") : i.addClass("single-image"), i.find(".gallery-cell").each(function() {
                        var e = 0;
                        $(this).find(".action_button").each(function() {
                            $(this).width() > e && (e = $(this).width())
                        }), $(this).find(".action_button").width(e)
                    })
                })
            },
            unload: function(e) {
                e.find(".js-testimonial").flickity("destroy")
            }
        },
        gallery = {
            init: function() {
                $(".gallery-horizontal").find(".gallery-image-wrapper").each(function() {
                    var e, t, i = $(this),
                        o = $(this).find("img");
                    $("<img />").attr("src", $(o).attr("src")).on("load", function() {
                        e = this.width, t = this.height, $(i).css("flex-basis", 200 * e / t), $(i).css("flex-grow", 200 * e / t), $(i).find("i").css("padding-bottom", t / e * 100 + "%")
                    })
                }), lightboxGallery.init()
            }
        },
        supports_video = function() {
            return !!document.createElement("video").canPlayType
        },
        videoSection = {
            init: function() {
                var e, t;
                $(".homepage-video").each(function(i, o) {
                    $(".homepage-video").length && supports_video() && (e = $(this), t = videoSection.getVideoSettings(e), is_touch_device() && $(window).width() <= 798 && !1 === t.posterImage || $(window).width() <= 798 && !1 === t.posterImage ? videoSection.appendFrame(e, t) : t.autoPlayVideo && $(window).width() > 798 ? videoSection.appendFrame(e, t) : !1 === t.autoPlayVideo && !1 === t.posterImage ? videoSection.appendFrame(e, t) : (e.find(".homepage-video__placeholder").show(), e.find(".placeholder-svg--video").show()))
                }), $("body").on("click", ".video__play-button", function(i) {
                    e = $(this).parents(".video-section").find(".homepage-video"), $(this).fadeOut(), t = videoSection.getVideoSettings(e), e.find(".mediaWrapper").length < 1 && e.find("video").length < 1 && videoSection.appendFrame(e, t)
                }), $("body").on("click", "[data-play-video]", function(i) {
                    e = $(this).parents(".video-section").find(".homepage-video"), $(this).fadeOut(), t = videoSection.getVideoSettings(e), e.find(".mediaWrapper").length < 1 && e.find("video").length < 1 && videoSection.appendFrame(e, t)
                })
            },
            getVideoSettings: function(e) {
                return {
                    container: e.find(".homepage-video"),
                    header: e.find(".homepage-video--media"),
                    posterImage: e.data("poster-image"),
                    videoText: e.find(".homepage-video--media .caption"),
                    videoTrigger: e.find("[data-play-video]"),
                    autoPlayVideo: e.data("autoplay"),
                    displayTextOverVideo: e.data("display-text-over-video"),
                    autoloop: e.data("autoloop"),
                    id: e.attr("data-video-src"),
                    aspectRatio: e.attr("data-aspect-ratio").split(":"),
                    provider: e.attr("data-provider").toLowerCase(),
                    videoMP4: e.attr("data-video-mp4"),
                    videoOGV: e.attr("data-video-ogv")
                }
            },
            createFrame: function(e) {
                var t, i, o, n = "";
                return "youtube" === e.provider ? (t = e.autoloop ? "1&iv_load_policy=3&playlist=" + e.id : 0, o = !1 === e.posterImage && !1 === e.autoPlayVideo ? 0 : 1, 1, i = '<iframe src="//www.youtube.com/embed/' + e.id + "?&autoplay=" + o + "&loop=" + t + '&rel=0&hd=1&showinfo=0&color=white&controls=0" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen ></iframe>') : "vimeo" === e.provider ? (o = !1 === e.posterImage && !1 === e.autoPlayVideo ? 0 : 1, t = e.autoloop ? 1 : 0, i = '<iframe src="//player.vimeo.com/video/' + e.id + "?loop=" + t + "&amp;title=0&amp;byline=0&amp;portrait=0&amp;color=3d96d2&autoplay=" + o + '" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen ></iframe>') : "html5" === e.provider && (!1 !== e.posterImage && (n = ' poster="https://' + e.posterImage), !1 === e.posterImage && !1 === e.autoPlayVideo && 0 === is_touch_device() ? o = " " : e.autoPlayVideo && !1 !== e.posterImage ? (n = ' poster="https://' + e.posterImage, o = " autoplay ") : o = " autoplay ", e.autoloop && (t = ' loop="loop" '), i = "<video " + "" + o + t + n + ' id="video" onclick="this.paused?this.play():this.pause();" ><source src="' + e.videoMP4 + '" type="video/mp4"><source src="' + e.videoOGV + '" type="video/ogg" ></video>'), i
            },
            appendFrame: function(e, t) {
                if (!1 === t.displayTextOverVideo && t.videoText.fadeOut(), e.find(".video__play-button").fadeOut(), e.append(videoSection.createFrame(t)), "html5" != t.provider) {
                    var i = t.aspectRatio[1] / t.aspectRatio[0] * 100 + "%";
                    e.find("iframe").mediaWrapper({
                        intrinsic: !1,
                        baseWidth: t.aspectRatio[0],
                        baseHeight: t.aspectRatio[1]
                    }), e.css({
                        height: 0,
                        paddingBottom: i
                    })
                } else e.find(".homepage-video__image").hide()
            },
            unload: function(e) {
                e.find("[data-play-video]").off("click")
            }
        },
        cart = {
            init: function() {
                $("#cart_form .tos_agree").length && $("body").on("click", "#cart_form input[type='submit']", function() {
                    if (!$(this).parents("form").find(".tos_agree").is(":checked")) {
                        var e = '<p class="warning animated bounceIn">' + BUFFALO.translations.agree_to_terms_warning + "</p>";
                        return 0 == $("p.warning").length && $(this).before(e), !1
                    }
                    $(this).submit()
                })
            }
        },
        selectCallback = function(e, t) {
            var i = $(".product-" + t.product.id),
                o = $(".notify-form-" + t.product.id),
                n = $("form.product_form", i),
                a = n.data("variant-inventory");
//           	a = Array.from(a);
//           	console.log(n);
            e && e.featured_image && i.is(":visible") && $(".product_gallery", i).each(function() {
                var t = $(this),
                    i = Flickity.data(this);
                if (t.is(":visible") && void 0 != i) {
                    var o = $('[data-image-id="' + e.featured_image.id + '"]').data("index");
                    i.select(o, !1, !0)
                }
            });
            if (e)
                if (a && a.forEach(function(t) {
                        t.id === e.id && (e.inventory_quantity = t.inventory_quantity, e.inventory_management = t.inventory_management, e.inventory_policy = t.inventory_policy)
                    }), $(".sku span", i).text(e.sku), "swatches" == BUFFALO.product_form_style)
                    for (var r = 0, s = e.options.length; r < s; r++) {
                        var l = n.find('.swatch[data-option-index="' + escape(r) + '"] :radio[value="' + e.options[r].replace(/\"/g, '\\"') + '"]');
                        l.length && (l.get(0).checked = !0)
                    } else $(".notify_form_message", i).attr("value", $(".notify_form_message", i).data("body") + " - " + e.title);
                else e = t.product.variants.filter(function(e) {
                    return e.available
                })[0];
          
          /* HC - Variant inventory fix - 19 Nov '18 */
          var items_left_text = "";
            if (e && 1 == e.available) e.price < e.compare_at_price ? ($(".was_price", i).html('<span class="money">' + Shopify.formatMoney(e.compare_at_price, n.data("money-format")) + "</span>"), $(".savings", i).html(BUFFALO.translations.product_savings + " " + parseInt(100 * (e.compare_at_price - e.price) / e.compare_at_price) + '% (<span class="money">' + Shopify.formatMoney(e.compare_at_price - e.price, n.data("money-format")) + "</span>)")) : ($(".was_price", i).html(""), $(".savings", i).html("")), e.inventory_management && e.inventory_quantity > 0 ? (BUFFALO.display_inventory_left && (1 == e.inventory_quantity ? items_left_text = BUFFALO.translations.items_left_count_one : items_left_text = BUFFALO.translations.items_left_count_other, $(".items_left", i).html("<p><em>Only " + e.inventory_quantity + " " + items_left_text + " in stock!</em></p>")), BUFFALO.limit_quantity && "deny" == e.inventory_policy && $(".quantity", i).attr("max", e.inventory_quantity)) : ($(".items_left", i).text(""), $(".quantity", i).removeAttr("max")), $(".sold_out", i).text(""), e.price > 0 ? $(".current_price", i).html('<span class="money">' + Shopify.formatMoney(e.price, n.data("money-format")) + "</span>") : $(".current_price", i).html(BUFFALO.free_price_text), $(".add_to_cart", i).removeClass("disabled").removeAttr("disabled").find("span").text($(".add_to_cart", i).data("label")), o.hide();
            else {
                var c = e ? BUFFALO.translations.product_sold_out : BUFFALO.translations.product_unavailable;
                $(".was_price", i).text(""), $(".savings", i).text(""), $(".current_price", i).text(""), $(".items_left", i).text(""), $(".quantity", i).removeAttr("max"), $(".sold_out", i).text(c), $(".add_to_cart", i).addClass("disabled").attr("disabled", "disabled").find("span").text(c), e && o.fadeIn()
            }

          if (e.inventory_management == 'shopify' && e.inventory_quantity < 5 && e.inventory_quantity > 0){
            $('.items_left').show();
          }else{
            $('.items_left').hide();
          }

          
          
            BUFFALO.show_multiple_currencies && convertCurrencies()
        },
        productPage = {
            init: function() {
                var e = !0,
                    t = !0;
                setTimeout(function() {
                    imageFunctions.linkGalleryAndCarousel($(".js-product-page-gallery .product_gallery"), $(".js-product-page-gallery .product_gallery_nav"))
                }, 1e3), imageFunctions.zoom(".product_gallery", !1), $(".js-full-width-product-images").length && imageFunctions.fullWidth(".product-template .product .description img", ".js-full-width-product-images"), $(".product_gallery").hasClass("single-image") && (e = !1, t = !1);
                var i = $(".product_gallery").data("autoplay");
                $(".product_gallery").flickity({
                    wrapAround: "true",
                    cellAlign: "left",
                    draggable: e,
                    contain: !0,
                    imagesLoaded: !0,
                    lazyLoad: 2,
                    pageDots: usePageDots,
                    prevNextButtons: t,
                    autoPlay: !!i && 6e3,
                    selectedAttraction: .01,
                    friction: .15,
                    arrowShape: arrowSize
                }), $(".js-product_section .product_form_options").each(function() {
                    var e = $(this).data("product");
                    e.variants = e.variants.filter(function(e) {
                        return e.available
                    }), new Shopify.OptionSelectors($(this).data("select-id"), {
                        product: e,
                        onVariantSelected: selectCallback,
                        enableHistoryState: $(this).data("enable-state")
                    })
                }), $(".notify_form .contact-form").each(function() {
                    var e = $(this);
                    e.on("submit", function(t) {
                        "true" !== $('input[name="challenge"]', e).val() && ($.ajax({
                            type: e.attr("method"),
                            url: e.attr("action"),
                            data: e.serialize(),
                            success: function(t) {
                                e.fadeOut("slow", function() {
                                    e.prev(".message").html(BUFFALO.translations.notify_form_post_success)
                                })
                            },
                            error: function(t) {
                                $('input[name="challenge"]', e).val("true"), e.submit()
                            }
                        }), t.preventDefault())
                    })
                }), "swatches" === BUFFALO.product_form_style && $("body").on("change", ".swatch :radio", function() {
                    var e = $(this).closest(".swatch").attr("data-option-index"),
                        t = $(this).val(),
                        i = $(this).closest(".product_form");
                    if (i.siblings(".notify_form").length) var o = i.siblings(".notify_form");
                    else o = $(".js-notify-form");
                    var n = i.find(".swatch_options input:checked").eq(0).val(),
                        a = i.find(".swatch_options input:checked").eq(1).val() || "",
                        r = i.find(".swatch_options input:checked").eq(2).val() || "";
                    if (n && a && r) var s = n + " / " + a + " / " + r;
                    else if (n && a) s = n + " / " + a;
                    else s = n;
                    o.find(".notify_form_message").attr("value", o.find(".notify_form_message").data("body") + " - " + s), $(this).closest("form").find(".single-option-selector").eq(e).val(t).trigger("change")
                }), lightboxGallery.init()
            },
            relatedProducts: function() {
                $(".js-related-products-slider .products-slider").each(function(e, t) {
                    var i, o, n, a, r, s = $(this).data("products-per-slide"),
                        l = $(this).data("products-limit"),
                        c = $(this).data("products-available");
                    i = "2" == s && c > s && l > s || "4" == s && c > s && l > s || "6" == s && c > s && l > s ? "left" : "center", c > s && l > s ? (o = !0, n = !0, a = !0) : (o = !1, n = !1, a = !1), "2" == s && c > s || "4" == s && c > s || "6" == s && c > s ? r = 0 : "3" == s && c ? r = 1 : "5" == s && c ? r = 2 : "7" == s && c && (r = 3), $(window).width() <= 798 && (i = "center", o = !0, n = !0, a = !0, r = 1, $(this).parents(".even-num-slides").removeClass("even-num-slides")), $(this).flickity({
                        lazyLoad: 2,
                        imagesLoaded: !0,
                        draggable: o,
                        cellAlign: i,
                        prevNextButtons: n,
                        wrapAround: a,
                        pageDots: usePageDots,
                        contain: !0,
                        freeScroll: !0,
                        arrowShape: arrowSize,
                        initialIndex: r
                    })
                })
            },
            initializeQuantityBox: function() {
                $("body").on("click", ".js-change-quantity", function() {
                    var e = $(this),
                        t = $(this).siblings("input"),
                        i = parseInt(t.val()),
                        o = 1e29,
                        n = t.attr("min") || 0;
                    return null != t.attr("max") && (o = t.attr("max")), isNaN(i) || i < n ? (t.val(n), !1) : i > o ? (t.val(o), !1) : ("plus" == e.data("func") ? i < o && t.val(i + 1) : (i > n && t.val(i - 1), e.parents(".cart_item").length && i - 1 == 0 && e.closest(".cart_item").addClass("animated fadeOutUp")), void t.trigger("change"))
                })
            },
            unload: function(e) {
                e.find(".products-slider").flickity("destroy")
            }
        },
        newsletter_popup = {
            init: function() {
                var e = Cookies.get("popup"),
                    t = !!BUFFALO.newsletter_popup_days;
                if (t && "open" == e) return !1;
                newsletter_popup.open(), t && Cookies.set("popup", "open", {
                    expires: BUFFALO.newsletter_popup_days
                })
            },
            open: function() {
                (BUFFALO.newsletter_popup_mobile || $(window).width() > 798) && setTimeout(function() {
                    $("[data-remodal-id=newsletter]").remodal().open()
                }, 1e3 * (BUFFALO.newsletter_popup_seconds || 2))
            }
        },
        header = {
            init: function() {
                $(".promo_banner").length && ("dismiss" != Cookies.get("promo_banner") && ($("body").addClass("promo_banner-show"), $(".promo_banner").on("click", ".promo_banner-close", function() {
                    $("body").removeClass("promo_banner-show"), Cookies.set("promo_banner", "dismiss", {
                        expires: 30
                    })
                })));
                if ($(".vertical-menu_submenu, .vertical-menu_sub-submenu").each(function() {
                        $(this).is(":off-right") && $(this).addClass("vertical-menu--align-right")
                    }), $(window).width() > 798 ? ($(".DesktopHeader").hasClass("sticky_nav") || ($(".DesktopHeader").append($("#site-menus").children()), new Headhesive(".DesktopHeader", {
                        offset: 700,
                        throttle: 300,
                        classes: {
                            clone: "sticky_nav",
                            stick: "sticky_nav--stick",
                            unstick: "sticky_nav--unstick"
                        },
                        onInit: function() {
                            $(".sticky_nav .nav:last").prepend($(".header .cart_container").clone()), $("[id]", ".sticky_nav").each(function() {
                                this.id += "_sticky_clone"
                            }), $("[for]", ".sticky_nav").each(function() {
                                this.htmlFor += "_sticky_clone"
                            })
                        },
                        onUnstick: function() {
                            $(".cart_container").removeClass("active_link")
                        }
                    })), $(".header_search_form").on("blur", 'input[name="q"]', function() {
                        var e = this;
                        $(this).data("blur_timeout", setTimeout(function() {
                            e.value = ""
                        }, 1e3))
                    }).on("focus", 'input[name="q"]', function() {
                        clearTimeout($(this).data("blur_timeout"))
                    }).on("submit", function() {
                        var e = this;
                        requestAnimationFrame(function() {
                            clearTimeout($('input[name="q"]', e).addClass("visible").data("blur_timeout"))
                        })
                    }), $("img.primary_logo:visible") ? $(".logo img", $(".feature_image .header")).attr("src", $(".logo img").data("src-home")) : $(".logo img").attr("src", $(".logo img").data("src"))) : $("#header").hasClass("mobile_nav-fixed--true") ? $("body").addClass("mobile_nav-fixed--true") : $("body").addClass("mobile_nav-fixed--false"), $("#header .cart_container").append($(".cart_content").clone()), $(window).width() <= 798) {
                    $(".dropdown_link").attr("data-no-instant", !0), $("body").on("click", ".dropdown_link", function(e) {
                        $(".active_link").removeClass("active_link");
                        var t = $(this).closest("header"),
                            i = t.find('[data-dropdown="' + $(this).data("dropdown-rel") + '"]');
                        if (t.is(":visible")) $(this).hasClass("mini_cart") || $(".cart_container").removeClass("active_link");
                        else if ($(this).hasClass("icon-search")) return window.location = $(this).attr("href"), !1;
                        if (i.is(":visible") || void 0 === i.attr("class") ? (i.hide(), $("body").removeClass("is-active")) : ($(".dropdown_container").hide(), $(this).hasClass("cart_container") || $(".is-absolute").parent().removeClass("feature_image"), i.show(), $("body").addClass("is-active"), $(".mobile_nav").find("div").removeClass("open")), i.is(":visible")) return e.stopPropagation(), !1
                    }), $("body").on("click", ".mobile_nav", function() {
                        $(this).find("div").toggleClass("open")
                    });
                    var e = function() {
                        $("body").removeClass("is-active"), $(".dropdown_link").toggleClass("active_link"), $(".cart_container").removeClass("active_link")
                    };
                    $("html").on("click", function(t) {
                        !$(t.target).closest(".cart_container").length && $(".cart_content").is(":visible") && e(), !$(t.target).closest(".dropdown_container").length && $(".dropdown").is(":visible") && ($("body").removeClass("is-active"), $(".dropdown_link").removeClass("active_link"), $(".dropdown_container").hide(), $(".mobile_nav").find("div").removeClass("open"))
                    }), $(".mini_cart").on("click", function(t) {
                        var i = $(this).parent();
                        i.hasClass("active_link") ? e() : function(e) {
                            $(".mobile_nav div").removeClass("open"), $(".dropdown_link").removeClass("active_link"), e.addClass("active_link")
                        }(i), (is_touch_device() || $(window).width() <= 798) && t.preventDefault()
                    }), $(".cart_content__continue-shopping").on("click", function(t) {
                        e()
                    })
                } else $(".main_nav_wrapper, .top_bar, .cart_container").on("mouseleave", function() {
                    $(".dropdown_container").hide(), $(".active_link").removeClass("active_link")
                }), $(".dropdown_link, .dropdown_link--vertical").attr("data-click-count", 0), $("body").on("mouseenter touchstart", ".dropdown_link", function(e) {
                    var t = $(this).closest("header").find('[data-dropdown="' + $(this).data("dropdown-rel") + '"]'),
                        i = $(this).attr("data-click-count");
                    if ($(".active_link").removeClass("active_link"), t.show(), $(this).hasClass("mini_cart") ? $(this).parent(".cart_container").addClass("active_link") : ($(this).addClass("active_link"), $(".is-absolute").parent().removeClass("feature_image")), is_touch_device() && ($(".dropdown_link").not(this).attr("data-click-count", 0), $(".dropdown_link").attr("data-no-instant", !0), "touchstart" === e.type && (i++, $(this).attr("data-click-count", i), i < 2))) return e.preventDefault(), e.stopPropagation(), !1
                })
            },
            removeDataAttributes: function(e) {
                if ($(e).length) {
                    var t, i = $(e),
                        o = [],
                        n = i.get(0).attributes,
                        a = n.length;
                    for (t = 0; t < a; t++) "data-" === n[t].name.substring(0, 5) && o.push(n[t].name);
                    $.each(o, function(e, t) {
                        i.removeAttr(t)
                    })
                }
            },
            loadMegaMenu: function() {
                header.removeDataAttributes(".sticky_nav .mega-menu.dropdown_container .dropdown_column"), header.removeDataAttributes(".header .mega-menu.dropdown_container .dropdown_column"), (is_touch_device() || $(window).width() <= 798) && $(".dropdown_link").attr("data-no-instant", !0), header.loadMobileMegaMenu()
            },
            loadMobileMegaMenu: function() {
                $(".mega-menu-container .mobile-mega-menu").each(function(e) {
                    $('[data-mobile-dropdown-rel="' + $(this).data("mobile-dropdown") + '"]').find("span").remove(), $('[data-mobile-dropdown-rel="' + $(this).data("mobile-dropdown") + '"] > a').append(' <span class="right icon-down-arrow"></span>').attr("data-no-instant", "true"), $('[data-mobile-dropdown-rel="' + $(this).data("mobile-dropdown") + '"]').addClass("mobile-mega-menu-parent sublink"), $('[data-mobile-dropdown-rel="' + $(this).data("mobile-dropdown") + '"]').append(this), $('[data-mobile-dropdown-rel="' + $(this).data("mobile-dropdown") + '"] > ul').each(function(e) {
                        $(this).hasClass("mobile-mega-menu") || $(this).remove()
                    })
                })
            },
            unloadMegaMenu: function() {},
            unload: function() {
                $("body").off("click", ".mobile_nav"), $("body").off("click", ".dropdown_link"), $("html").off("click"), $(".mini_cart").off("click"), $(".cart_content__continue-shopping").off("click")
            }
        },
        enableLoadMoreProducts = function() {
            $("body").on("click", ".js-load-more a", function(e) {
                return enableInfiniteScroll(), e.stopPropagation(), !1
            })
        },
        enableInfiniteScroll = function() {
            new Waypoint.Infinite({
                element: $(".collection-matrix")[0],
                items: ".collection-matrix",
                more: ".load-more__btn",
                loadingClass: "loading-in-progress",
                onBeforePageLoad: function() {
                    $(".js-load-more").hide()
                },
                onAfterPageLoad: function(e) {
                    BUFFALO.enable_shopify_collection_badges && SPR.$(document).ready(function() {
                        return SPR.registerCallbacks(), SPR.initRatingHandler(), SPR.initDomEls(), SPR.loadProducts(), SPR.loadBadges()
                    }), BUFFALO.show_multiple_currencies && convertCurrencies()
                }
            })
        };
    if (Shopify.queryParams = {}, location.search.length)
        for (var aKeyValue, i = 0, aCouples = location.search.substr(1).split("&"); i < aCouples.length; i++) aKeyValue = aCouples[i].split("="), aKeyValue.length > 1 && (Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]));
    var quickFilter = {
        init: function() {
            var e = [],
                t = "",
                i = "",
                o = ($.url("hostname"), $.url("1") ? "/" + $.url("1") + "/" : ""),
                n = $.url("2") ? $.url("2") + "/" : "",
                a = ($.url("3"), o + n);
            t = $("#sort-by").length ? $("#sort-by").val() : url("?sort_by"), $("#tag_filter").length && $("#tag_filter").data("default-collection") != $("#tag_filter").val() && (urlTag = $("#tag_filter").val().substr($("#tag_filter").val().lastIndexOf("/") + 1), "all" != urlTag && ($.inArray(urlTag, e) > -1 || e.unshift(urlTag))), $("[data-option-filter] input:checked").each(function() {
                e.push($(this).val())
            }), e = $.makeArray(e), $.each(e, function(t, o) {
                t != e.length - 1 ? i += e[t] + "+" : i += e[t]
            }), Shopify.queryParams.sort_by = t, t = "?" + $.param(Shopify.queryParams), quickFilter.processUrl(a, i, t)
        },
        updateView: function(e) {
            $.ajax({
                type: "GET",
                url: e,
                beforeSend: function() {
                    $(".collection-matrix").addClass("fadeOut animated loading-in-progress filter-loading"), Waypoint.destroyAll()
                },
                success: function(t) {
                    $(".collection-matrix").removeClass("loading-in-progress"), $(".collection-matrix").removeClass("filter-loading");
                    var i = $(t).find(".breadcrumb_text").html();
                    $(".breadcrumb_text").html(i);
                    var o = $(t).find(".paginate").html();
                    $(".paginate").html(o);
                    var n = $(t).find(".sidebar").html();
                    $(".sidebar").html(n);
                    var a = $(t).find(".paginate").html();
                    $(".paginate").empty(), $(".paginate").html(a);
                    var r = $(t).find(".collection-matrix");
                    $(".collection-matrix").remove(), r.insertBefore($(".load-more__icon")), window.history && window.history.pushState && window.history.pushState("", "", e), $(".sidebar__collection-filter").length && collectionSidebarFilter.init(), "infinite_scroll" === BUFFALO.pagination_type && enableInfiniteScroll(), BUFFALO.show_multiple_currencies && convertCurrencies(), BUFFALO.enable_shopify_collection_badges && SPR.$(document).ready(function() {
                        return SPR.registerCallbacks(), SPR.initRatingHandler(), SPR.initDomEls(), SPR.loadProducts(), SPR.loadBadges()
                    })
                },
                error: function(t, i, o) {
                    console.log(t), console.log(i), console.log(o), location.replace(location.protocol + "//" + location.host + e)
                },
                dataType: "html"
            })
        },
        processUrl: function(e, t, i) {
            var o;
            o = e + t + (i = i.replace(/\page=(\w+)&/, "")), quickFilter.updateView(o)
        }
    };
    $("#sort-by").val($("#sort-by").data("default-sort")), $("body").on("change", "#tag_filter, #sort-by", function() {
        quickFilter.init()
    }), $("body").on("change", "#blog_filter", function() {
        var e = $(this).val();
        window.location = e
    }), $("input, select, textarea").on("focus blur", function(e) {
        $("meta[name=viewport]").attr("content", "width=device-width,initial-scale=1,maximum-scale=" + ("blur" == e.type ? 10 : 1))
    });
    var collectionSidebarFilter = {
        init: function() {
            $(".sidebar .hide-sidebar-toggle").on("click", function() {
                $(".sidebar").toggleClass("is-hidden")
            }), $(".filter-active-tag input:checked").parents(".filter-active-tag").siblings(".filter-all-tags").hide(), $(".toggle-all--true .toggle_list .filter-active-tag input:checked").parents("ul.toggle_list").prev().click(), "types" !== $.url(2) && "vendors" !== $.url(2) || $(".sidebar__collection-filter").remove(), $(".sidebar-block:empty").prev().css("border-bottom", "none")
        },
        clearAllFilters: function() {
            $("[data-option-filter] input").attr("checked", !1), $("[data-option-filter] input").trigger("change")
        },
        clearSelectedFilter: function(e) {
            e.find("[data-option-filter] input").attr("checked", !1), e.find("[data-option-filter] input").trigger("change")
        }
    };
    $("body").on("change", "[data-option-filter] input", function() {
        quickFilter.init()
    }), $("body").on("click", "[data-reset-filters]", function() {
        collectionSidebarFilter.clearAllFilters()
    }), $("body").on("click", "[data-clear-filter]", function() {
        var e = $(this).parents(".filter-active-tag");
        collectionSidebarFilter.clearSelectedFilter(e)
    });
    var faqAccordion = {
            init: function() {
                var t = 0,
                    i = $(".faqAccordion > dt > button");
                $(".faqAccordion > dd").attr("aria-hidden", !0), i.attr("aria-expanded", !1), i.on("click activate", function() {
                    if (t) return !1;
                    t = 1;
                    var e = "false" === $(this).attr("aria-expanded");
                    return $(this).attr("aria-expanded", e), $(this).parent().next().slideToggle(function() {
                        t = 0
                    }), $(this).parent().next().attr("aria-hidden", !e), !1
                }), i.on("keydown", function(t) {
                    13 === (t.keyCode || e.which) && $(this).trigger("activate")
                })
            }
        },
        arrowSize = "m31,97.6102c5.75872,-18.47159 18.87712,-34.90276 37.05936,-47.61185c-18.18224,-12.71294 -31.30064,-29.14027 -37.05936,-47.608",
        lightboxGallery = {
            init: function() {
                if ($(".lightbox img").length) {
                    var e = [];
                    $("a.lightbox").each(function(t) {
                        e.push($(this).attr("rel")), e = e.filter(function(e, t, i) {
                            return i.indexOf(e) === t
                        })
                    }), $.each(e, function(e, t) {
                        $(".lightbox[rel=" + t + "]").attr("data-remodal-target", "lightbox-id-" + e);
                        var i = ['<div class="remodal remodal-lightbox js-remodal-lightbox js-lightbox-' + e + '" data-rel="' + t + '" data-remodal-id="lightbox-id-' + e + '" data-remodal-options="hashTracking: false">', '<a data-remodal-action="close" class="remodal-close"></a>', '<div class="lightbox-gallery"></div>', "</div>"].join("");
                        $("body").append(i), $(".lightbox[rel=" + t + "]").each(function(e) {
                            $(this).attr("data-image-id", e), $(this).attr("data-no-instant", "")
                        })
                    })
                }
            }
        },
        utils = {
            createAccordion: function(e, t, i) {
                var o = $(e),
                    n = $(e).find(t),
                    a = $(e).find(i),
                    r = e + " " + t;
                if (e.indexOf(".accordion-tabs") >= 0) {
                    var s = $.map(n, function(e, t) {
                        return [e, a[t]]
                    });
                    o.empty(), $.each(s, function(e, t) {
                        o.append(this)
                    }), a.removeClass("active"), o.find(".active").next().slideToggle(), t = e + "> a"
                }
                $(e).children("a").each(function(e, t) {
                    var i = (t = $(this)).attr("href");
                    t.attr("data-tab-value", i), t.removeAttr("href")
                }), $(e).find(t + ".active").next().slideToggle(), $("body").on("click", r, function(e) {
                    e.preventDefault(), $(this).toggleClass("active"), $(this).next().slideToggle()
                })
            },
            mobileAccordion: function(e, t, i) {
                $(t + ".active").next().slideToggle(), $("body").on("click", t, function(e) {
                    e.preventDefault(), $(this).hasClass("active") || $(".active", "#mobile_menu").removeClass("active").next().slideToggle(), $(this).toggleClass("active"), $(this).next().slideToggle()
                })
            },
            mobileParentActiveAccordion: function(e, t, i) {
                $(t + ".active").parent().next().slideToggle(), $("body").on("click", t, function(e) {
                    e.preventDefault(), $(this).hasClass("active") || $(".icon-down-arrow.active", "#mobile_menu").removeClass("active").parent().next().slideToggle(), $(this).toggleClass("active"), $(this).parent().next().slideToggle()
                })
            },
            initializeTabs: function() {
                $("ul.tabs > li > a").attr("data-no-instant", !0), $("body").on("click", "ul.tabs > li > a", function(e) {
                    e.preventDefault();
                    var t = $(this).attr("href");
                    "#" == t.charAt(0) && ($("ul.tabs > li > a.active").removeClass("active"), $(this).addClass("active"), $(this).parents("ul.tabs").next().find(t).show().css({
                        display: "block"
                    }).addClass("active").siblings().hide().removeClass("active"))
                })
            },
            pageBannerCheck: function() {
                !$(".page_banner").length > 0 || $(".header").hasClass("header-background--solid") ? ($(".feature_image").removeClass("feature_image"), $(".header.is-absolute").removeClass("is-absolute")) : ($(".header").addClass("is-absolute"), $("header.feature_image").hasClass("secondary_logo--true")), $(".index-sections").children().first().hasClass("under-menu") ? ($(".header").hasClass("header-background--solid") || $(".index .header").addClass("is-absolute"), $("header.feature_image").hasClass("secondary_logo--true")) : ($(".index .feature_image").removeClass("feature_image"), $(".index .header.is-absolute").removeClass("is-absolute"), $("header.feature_image").hasClass("secondary_logo--true")), $(".detail-sections").children().first().hasClass("under-menu") ? ($(".header").hasClass("header-background--solid") || $('[class^="page-details"] .header').addClass("is-absolute"), $("header.feature_image").hasClass("secondary_logo--true")) : ($('[class^="page-details"] .feature_image').removeClass("feature_image"), $('[class^="page-details"] .header.is-absolute').removeClass("is-absolute"), $("header.feature_image").hasClass("secondary_logo--true"))
            },
            resizeActionButtons: function() {}
        },
        sliderBlock = {
            select: function(e, t) {
                var i = t.find(".gallery-cell").map(function() {
                        return String($(this).data("block-id"))
                    }),
                    o = t.find(".js-homepage-slideshow"),
                    n = (o.data("slideshow-text-animation"), o.data("flickity"));
                o.flickity("pausePlayer");
                for (var a = 0; a < i.length; a++)
                    if (i[a] === e) {
                        var r = a;
                        r !== n.selectedIndex && o.flickity("select", parseInt(r), !1, !0)
                    }
            },
            deselect: function(e) {
                var t = e.find(".flexslider").data("flexslider");
                t && t.flickity("unpausePlayer")
            }
        };

    function htmlEncode(e) {
        return e ? $("<div/>").text(e).html() : ""
    }

    function is_touch_device() {
        return "ontouchstart" in window || navigator.maxTouchPoints
    }

    function floatToString(e, t) {
        var i = e.toFixed(t).toString();
        return i.match(/^\.\d+/) ? "0" + i : i
    }
    if ($(function() {
            var oldFlickityCreate = window.Flickity.prototype._create;
            if (window.Flickity.prototype._create = function() {
                    var e = this;
                    return this.element.addEventListener && this.element.addEventListener("load", function() {
                        e.onresize()
                    }, !0), this._create = oldFlickityCreate, oldFlickityCreate.apply(this, arguments)
                }, FastClick.attach(document.body), header.init(), header.loadMegaMenu(), utils.pageBannerCheck(), slideshow.init(), testimonial.init(), gallery.init(), videoSection.init(), featuredPromotions.init(), featuredCollectionSection.init(), collectionSidebarFilter.init(), cart.init(), productPage.initializeQuantityBox(), productPage.init(), productPage.relatedProducts(), recentlyViewed.init(), $("body").on("click", ".lightbox", function() {
//                     currentSlide = $(this).data("image-id")
                }), $("body").on("opened", ".js-remodal-lightbox", function() {
                    var e, t = $(this),
                        i = t.find(".lightbox-gallery"),
                        o = t.find(".lightbox-image"),
                        n = $("body").find(".product_gallery").data("zoom"),
                        a = 1 !== o.length,
                        r = $(this).data("rel"),
                        s = !0;
                    if (t.attr("data-zoom", n), s = !(n && $(window).width() <= 798) && 1 !== o.length, !i.hasClass("flickity-enabled")) i.flickity({
                        wrapAround: "true",
                        cellAlign: "left",
                        contain: !0,
                        imagesLoaded: !0,
                        lazyLoad: 2,
                        pageDots: usePageDots,
                        draggable: s,
                        prevNextButtons: a,
                        selectedAttraction: .01,
                        friction: .15,
                        arrowShape: arrowSize
                    });
                    $groupImages = $(".lightbox[rel=" + r + "]"), $groupImages.each(function(o) {
                        var n = $(this).attr("href");
                        e = $('<div class="gallery-cell"><img src="' + n + '" class="lightbox-image"></div>'), $groupImages.length > i.find(".gallery-cell").length && i.flickity("append", e), i.flickity("select", currentSlide, !1, !0).focus(), t.find(".lightbox-image").css("opacity", "1")
                    }), n && $(window).width() <= 798 && imageFunctions.zoom(".js-remodal-lightbox", !0, 1.8)
                }), $("body").on("closed", ".js-remodal-lightbox", function() {
                    $(this).find(".lightbox-image").css("opacity", "0")
                }), BUFFALO.newsletter_popup && newsletter_popup.init(), -1 != window.location.pathname.indexOf("/comments") && $("html,body").animate({
                    scrollTop: $("#new-comment").offset().top - 140
                }, "slow"), $("body").on("mouseenter", ".icon-search", function() {
                    $(".search-terms").focus()
                }), $("body").on("click", ".search-submit", function() {
                    var e = $(this).parent();
                    e.isValid() ? e.submit() : e.find(":input").eq(0).focus()
                }), $(window).width() > 798 && ($(".animate_right").waypoint(function() {
                    $(this.element).addClass("animated fadeInRight")
                }, {
                    offset: "70%"
                }), $(".animate_left").waypoint(function() {
                    $(this.element).addClass("animated fadeInLeft")
                }, {
                    offset: "70%"
                }), $(".animate_up").waypoint(function() {
                    $(this.element).addClass("animated fadeInUp")
                }, {
                    offset: "70%"
                }), $(".animate_down").waypoint(function() {
                    $(this.element).addClass("animated fadeInDown")
                }, {
                    offset: "70%"
                })), $(".slider, .flexslider").find("li").unwrap(), $(".slider, .flexslider").flickity({
                    pageDots: usePageDots,
                    imagesLoaded: !0,
                    lazyLoad: 2
                }), utils.createAccordion(".toggle-all--true", "h2.toggle", "ul.toggle_list"), utils.createAccordion(".footer_menu", "h6", "ul"), utils.createAccordion(".footer_content", "h6", "div.toggle_content"), utils.createAccordion(".product_section .accordion-tabs", ".tabs li > a", ".tabs-content li"), utils.mobileParentActiveAccordion("#mobile_menu", "li.sublink > a.parent-link--true span", "li.sublink ul"), utils.mobileAccordion("#mobile_menu", "li.sublink > a.parent-link--false", "li.sublink ul"), utils.initializeTabs(), utils.resizeActionButtons(), faqAccordion.init(), $(window).on("resize", function() {
                    utils.resizeActionButtons()
                }), $(window).width() <= 798 && utils.createAccordion(".toggle-all--false", "h2.toggle", "ul.toggle_list"), $("body").on("click", ".menu-toggle", function(e) {
                    $(this).next("ul").slideToggle(), $(this).toggleClass("active"), $(this).attr("aria-expanded", "true" == $(this).attr("aria-expanded") ? "false" : "true")
                }), $(".shopify-section.page-details-section").length || ($("body").hasClass("index") ? $(".featured-products-section iframe[src*=youtube], .featured-products-section iframe[src*=vimeo]").mediaWrapper({
                    intrinsic: !0
                }) : $("iframe[src*=youtube], iframe[src*=vimeo]").mediaWrapper({
                    intrinsic: !0
                })), $(window).width() >= 959) {
                var modal_width = "870px";
                ($(window).width() >= 1200 || $("html").hasClass("ie")) && (modal_width = "1110px")
            }
            BUFFALO.collection_swatches && $(window).width() > 798 && ($("body").on("mouseenter", ".collection_swatches", function() {
                $(".swatch span", $(this)).each(function() {
                    -1 == $(this).data("image").indexOf("no-image") && ($("<img/>")[0].src = $(this).data("image"))
                })
            }), $("body").on("mouseenter", ".swatch span", function() {
                -1 == $(this).data("image").indexOf("no-image") && ($(this).parents(".thumbnail").find("img:not(.secondary)").attr("src", $(this).data("image")), $(this).parents(".thumbnail").find("img:not(.secondary)").attr("srcset", $(this).data("image")))
            })), BUFFALO.display_tos_checkbox && $("body").on("click touchstart", ".cart_content .tos_label", function() {
                $(this).prev("input").prop("checked", !0)
            }), BUFFALO.display_tos_checkbox && BUFFALO.go_to_checkout ? $("body").on("click", ".cart_content .action_button", function(e) {
                if (!$(this).parents("form").find(".tos_agree").is(":checked")) {
                    var t = '<p class="warning animated bounceIn">' + BUFFALO.translations.agree_to_terms_warning + "</p>";
                    return 0 == $("p.warning").length && $(this).before(t), !1
                }
                $(this).submit()
            }) : BUFFALO.go_to_checkout && $("body").on("click", ".cart_content .action_button", function(e) {
                e.preventDefault(), document.location.href = "/cart"
            }), BUFFALO.collection_secondary_image && imageFunctions.showSecondaryImage();
            var $contact_form = $(".newsletter .contact-form"),
                globalQuickShopProduct;
            $contact_form.each(function() {
                var e = $(this);
                e.on("submit", function(t) {
                    "true" !== $('input[name="challenge"]', e).val() && ($.ajax({
                        type: e.attr("method"),
                        url: e.attr("action"),
                        data: e.serialize(),
                        success: function(t) {
                            e.fadeOut("slow", function() {
                                e.prev(".message").html(BUFFALO.translations.newsletter_form_success_text)
                            })
                        },
                        error: function(t) {
                            $('input[name="challenge"]', e).val("true"), e.submit()
                        }
                    }), t.preventDefault())
                })
            }), $(".maps").click(function() {
                $(".maps iframe").css("pointer-events", "auto")
            }), "load_more" === BUFFALO.pagination_type && enableLoadMoreProducts(), "infinite_scroll" === BUFFALO.pagination_type && enableInfiniteScroll(), $("body").on("change", ".currencies", function(e) {
                $("[data-initial-modal-price]").attr("data-initial-modal-price", "")
            }), $("body").on("change", ".js-quick-shop select", function(e) {
                var t = $('.js-quick-shop select[name="id"]').val();
                t && globalQuickShopProduct && quickShop.updateVariant(t)
            });
            var quickShop = {
                init: function() {
                    var e, t, i;
                    $("body").on("click", ".js-quick-shop-link", function(o) {
                        o.preventDefault();
                        for (var n = $(this).data("images").trim("||").split("||"), a = [], r = [], s = 0; s < n.length; s += 2) a.push(n[s]), n[s + 1] && r.push(n[s + 1]);
                        e = {
                            handle: $(this).data("handle"),
                            product_id: $(this).data("id"),
                            single_variant: $(this).attr("data-single-variant"),
                            product_in_collection_url: $(this).data("url"),
                            escaped_title: $(this).data("title"),
                            details_text: $(this).data("details-text"),
                            full_description: $(this).data("full-description"),
                            regular_description: $(this).data("regular-description"),
                            image_ids: a.filter(function(e) {
                                return "" !== e
                            }),
                            image_alts: r,
                            collection_handles: $(this).data("collection-handles").trim(",").split(","),
                            money_format: $(this).data("money-format")
                        }, $(".js-gallery-modal").hasClass("flickity-enabled") || $(".js-gallery-modal").flickity({
                            wrapAround: "true",
                            cellAlign: "left",
                            contain: !0,
                            imagesLoaded: !0,
                            lazyLoad: 2,
                            pageDots: usePageDots,
                            prevNextButtons: !0,
                            autoPlay: autoplay,
                            selectedAttraction: .01,
                            friction: .15,
                            arrowShape: arrowSize
                        }), i = $(this).next(".js-forms").find(".notify_form"), t = $(this).next(".js-forms").find(".product_form"), $(".quick-shop .container").attr("class", "container section product-" + e.product_id), $(".quick-shop .container").attr("id", "product-" + e.product_id), $(".quick-shop .container").attr("data-id", e.product_id), quickShop.retrieveProductInfo(e)
                    }), $("body").on("opened", ".js-quick-shop", function() {
                        if ($(".remodal.quick-shop .js-product-form").html(t), $(".remodal.quick-shop .js-notify-form").html(i), $(t).hasClass("product_form_options") && !$(t).hasClass("viewed")) {
                            var e = $(t).data("product");
                            e.variants = e.variants.filter(function(e) {
                                return e.available
                            }), new Shopify.OptionSelectors($(t).data("select-id"), {
                                product: e,
                                onVariantSelected: selectCallback,
                                enableHistoryState: $(t).data("enable-state")
                            })
                        } else BUFFALO.show_multiple_currencies && convertCurrencies();
                        if ("swatches" === BUFFALO.product_form_style) {
                            var o = $(t).data("product");
                            $(t).find(".swatch_options .swatch").length > 1 && Shopify.linkOptionSelectors(o, ".js-quick-shop")
                        }
                        utils.initializeTabs(), $('.js-quick-shop select[name="id"]').trigger("change")
                    }), $("body").on("closed", ".js-quick-shop", function(t) {
                        var i = $(".js-quick-shop .product_form"),
                            o = $(".js-quick-shop .notify_form");
                        $(".form-holder-" + e.product_id).append(i), $(".form-holder-" + e.product_id).append(o), $(".form-holder-" + e.product_id + " .product_form").addClass("viewed"), $(".form-holder-" + e.product_id + " .notify_form").addClass("viewed");
                        var n = $(".js-current-price .money").text();
                        $(".js-quick-shop-link[data-id=" + e.product_id + "]").attr("data-initial-modal-price", n), $(".js-current-price, .js-was-price, .js-savings").empty()
                    })
                },
                retrieveProductInfo: function(e) {
                    $.ajax({
                        dataType: "json",
                        async: !1,
                        cache: !1,
                        url: "/products/" + e.handle + ".js",
                        success: function(t) {
                            t = $.extend({}, t, e);
                            quickShop.populateGallery(t), globalQuickShopProduct = t, quickShop.updateVariant(t.variants[0].id.toString())
                        }
                    })
                },
                updateVariant: function(e) {
                    if ($(".js-sale-banner, .js-sold-out, .js-current-price, .js-was-price, .js-savings, .js-new-banner, .js-pre-order-banner").empty(), "undefined" != globalQuickShopProduct) {
                        var t = globalQuickShopProduct;
                        $(".modal_price, .js-notify-form").show(), $(".js-product-title").html('<a href="' + t.product_in_collection_url + '" title="' + t.escaped_title + '">' + t.title + "</a>"), $(".js-product-vendor").html('<a href="/collections/vendors?q=' + t.vendor + '">' + t.vendor + "</a>"), $(".js-full-description").html(t.full_description), $(".js-regular-description").html(t.regular_description);
                        var i = '<a href="' + t.product_in_collection_url + '" class="secondary_button" title="' + t.escaped_title + ' Details">' + t.details_text + "</a>";
                        if ($(".js-product-details").html(i), $.each(t.collection_handles, function(e, i) {
                                "new" == this.toString() && $(".js-new-banner").html(BUFFALO.translations.collections_new), "pre-order" == this.toString() && $(".js-pre-order-banner").html(BUFFALO.translations.collections_pre_order), "coming-soon" == this.toString() && (t.price = BUFFALO.translations.collections_coming_soon)
                            }), "true" == t.single_variant) BUFFALO.sale_banner_enabled && t.compare_at_price > t.price && $(".js-sale-banner").html(BUFFALO.translations.collections_sale), t.compare_at_price > t.price ? $(".js-current-price").addClass("sale") : $(".js-current-price").removeClass("sale"), 0 == t.available && $(".js-sold-out").html(BUFFALO.translations.product_sold_out), 1 == t.available && (t.compare_at_price > t.price && ($(".js-was-price").html('<span class="money">' + Shopify.formatMoney(t.compare_at_price, t.money_format) + "</span>"), $(".js-savings").html(BUFFALO.translations.product_savings + " " + parseInt(100 * (t.compare_at_price - t.price) / t.compare_at_price) + '% (<span class="money">' + Shopify.formatMoney(t.compare_at_price - t.price, t.money_format) + "</span>)")), t.price == BUFFALO.translations.collections_coming_soon ? $(".js-current-price").html(BUFFALO.translations.collections_coming_soon) : t.price ? $(".js-current-price").html('<span class="money">' + Shopify.formatMoney(t.price, t.money_format) + "</span>") : $(".js-current-price").html(BUFFALO.free_price_text));
                        else
                            for (var o = 0; o < t.variants.length; o++) e == t.variants[o].id.toString() && (BUFFALO.sale_banner_enabled && t.variants[o].compare_at_price > t.variants[o].price && $(".js-sale-banner").html(BUFFALO.translations.collections_sale), t.variants[o].compare_at_price > t.variants[o].price ? $(".js-current-price").addClass("sale") : $(".js-current-price").removeClass("sale"), 0 == t.variants[o].available && $(".js-sold-out").html(BUFFALO.translations.product_sold_out), 1 == t.variants[o].available && (t.variants[o].compare_at_price > t.variants[o].price && ($(".js-was-price").html('<span class="money">' + Shopify.formatMoney(t.variants[o].compare_at_price, t.money_format) + "</span>"), $(".js-savings").html(BUFFALO.translations.product_savings + " " + parseInt(100 * (t.variants[o].compare_at_price - t.variants[o].price) / t.variants[o].compare_at_price) + '% (<span class="money">' + Shopify.formatMoney(t.variants[o].compare_at_price - t.variants[o].price, t.money_format) + "</span>)")), t.variants[o].price == BUFFALO.translations.collections_coming_soon ? $(".js-current-price").html(BUFFALO.translations.collections_coming_soon) : t.variants[o].price ? $(".js-current-price").html('<span class="money">' + Shopify.formatMoney(t.variants[o].price, t.money_format) + "</span>") : $(".js-current-price").html(BUFFALO.free_price_text)))
                    }
                    BUFFALO.show_multiple_currencies && convertCurrencies(), $(".js-quick-shop iframe[src*=youtube], .js-quick-shop iframe[src*=vimeo]").mediaWrapper({
                        intrinsic: !0
                    })
                },
                populateGallery: function(e) {
                    var t = $(".js-gallery-modal"),
                        i = $(".js-gallery-carousel");

                    function o(i) {
                        $.each(e.images, function(i, o) {
                            var n, a = o.replace(/(\.[^.]*)$/, "_grande$1").replace("http:", ""),
                                r = o.replace(/(\.[^.]*)$/, "_1024x1024$1").replace("http:", ""),
                                s = o.replace(/(\.[^.]*)$/, "_2048x2048$1").replace("http:", ""),
                                l = e.image_alts[i];
                            n = l.indexOf("youtube") >= 0 ? '<div class="video-container youtube"><div>' + l + "</div></div>" : l.indexOf("vimeo") >= 0 ? '<div class="video-container vimeo"><div>' + l + "</div></div>" : '<img src="' + a + '" data-src="' + r + '" alt="' + l + '" data-image-id="' + e.image_ids[i].trim() + '" data-index="' + i + '" srcset="' + a + " 600w, " + r + " 1024w, " + s + ' 2048w" sizes="(min-width: 800px) 50vw, 100vw"/>';
                            var c = $('<div class="gallery-cell">' + n + "</div>");
                            t.flickity("append", c)
                        }), t.removeClass("single-image multi-image").addClass(i ? "multi-image" : "single-image")
                    }
                    $(document).on("closed", ".js-quick-shop", function(e) {
                        t.flickity("remove", $(".js-gallery-modal .gallery-cell")), i.empty()
                    }), e.images.length > 1 ? (o(!0), $.each(e.images, function(t, o) {
                        var n = '<img src="' + o.replace(/(\.[^.]*)$/, "_grande$1").replace("http:", "") + '" alt="' + e.image_alts[t] + '" />',
                            a = $('<div class="gallery-cell">' + n + "</div>");
                        i.append(a)
                    }), imageFunctions.linkGalleryAndCarousel(t, i)) : o(!1), imageFunctions.zoom(".js-gallery-modal", !1)
                }
            };
      

            function ajaxSubmitCart(e) {
                $cart = e, $.ajax({
                    url: "/cart/update.js",
                    dataType: "json",
                    cache: !1,
                    type: "post",
                    data: $cart.serialize(),
                    success: function(e) {
                        refreshCart(e)
                    }
                })
            }

            function ajaxUpdateCart(e, t, i) {
                $.ajax({
                    url: "/cart/change.js",
                    dataType: "json",
                    cache: !1,
                    type: "post",
                    data: {
                        quantity: t,
                        line: e
                    },
                    success: function(o) {
                        refreshCart(o);
                        var n = e - 1;
                        if (void 0 === o.items[n]) var a = 0;
                        else a = o.items[n].quantity;
                        if (t > 0 && t != a) {
                            items_left_text = 1 == a ? BUFFALO.translations.items_left_count_one : BUFFALO.translations.items_left_count_other, $(".warning--quantity").remove();
                            var r = '<p class="warning warning--quantity animated bounceIn">' + a + " " + items_left_text + "</p>";
                            i.find("input[data-line-id='" + e + "']").parent().after(r), i.find("input[data-line-id='" + e + "']").val(a)
                        } else i.is("#cart_form") && $("#cart_form").submit()
                    }
                })
            }

            function refreshCart(e) {
              	
              window.updateShippinginfo(e.total_price);
              console.log('fdafdasfdsa');
              console.log(e.total_price);
              
                var t = $(".cart_count");
                var mcc = $(".mobile-cart_count");
                var scc = $(".sl-cart_count");
                var dcc = $("#ccount");
                t.empty();
                var i = "",
                    o = "",
                    n = "",
                    a = $(".cart_content form"),
                    r = 0,
                    s = 0;
                t.text(e.item_count), mcc.text(e.item_count), scc.text(e.item_count), dcc.attr("data-items", e.item_count), 0 == e.item_count ? ($(".js-empty-cart__message").removeClass("hidden"), $(".js-cart_content__form").addClass("hidden")) : ($(".js-empty-cart__message").addClass("hidden"), $(".js-cart_content__form").removeClass("hidden"), $.each(e.items, function(e, t) {
                    var o = e + 1;
                    i += '<li class="cart_item clearfix"><a href="#" class="rm_item" data-item="' + o + '">X</a><a href="' + t.url + '">', t.image && (i += '<div class="cart_image"><img src="' + t.image.replace(/(\.[^.]*)$/, "_compact$1").replace("http:", "") + '" alt="' + htmlEncode(t.title) + '" /></div>'), i += '<div class="item_title">' + t.title, t.properties && $.each(t.properties, function(e, t) {
                        t && (i += '<div class="line-item">' + e + ": " + t + "</div>")
                    }), i += "</div></a>", i += '<strong class="right price">', BUFFALO.display_savings && $.ajax({
                        dataType: "json",
                        async: !1,
                        cache: !1,
                        url: "/products/" + t.handle + ".js",
                        success: function(e) {
                            var o = t.variant_id,
                                n = $.grep(e.variants, function(e) {
                                    return e.id == o
                                });
                            n[0] && n[0].compare_at_price > t.price && (i += ' <span class="money was_price">' + Shopify.formatMoney(n[0].compare_at_price, a.data("money-format")) + "</span> ", r += t.price * t.quantity, s += n[0].compare_at_price * t.quantity);
                        }
                    }), i += '<span class="money">' + Shopify.formatMoney(t.price, a.data("money-format")) + "</span></strong>", i += '<div class="left product-quantity-box"><span class="ss-icon product-minus js-change-quantity" data-func="minus"><span class="icon-minus"></span></span><input type="number" min="0" class="quantity" name="updates[]" id="updates_' + t.id + '" value="' + t.quantity + '" data-line-id="' + o + '" /><span class="ss-icon product-plus js-change-quantity" data-func="plus"><span class="icon-plus"></span></span></div></li>'
                }), o += '<span class="right"><span class="money">' + Shopify.formatMoney(e.total_price, a.data("money-format")) + "</span></span><span>" + BUFFALO.translations.subtotal + "</span>", n = s > 0 ? '<span class="right"><span class="money">' + Shopify.formatMoney(s - r, a.data("money-format")) + "</span></span><span>" + BUFFALO.translations.savings + "</span>" : ""), $(".js-cart_items").html(i), $(".js-cart_subtotal").html(o), $(".js-cart_savings").html(n), BUFFALO.show_multiple_currencies && convertCurrencies()
            }
      
            $('body').on('click', '.rm_item', function() {      
              var lineitem = $(this).data('item');
              ajaxUpdateCart(lineitem, 0, $(this).parents("#cart_form"))
            });
       		$( ".cart_container .mini_cart.dropdown_link, .cart-icon" ).click(function() {
                if (!$('body').hasClass("cart")) {
  					$( "body" ).addClass('sl-open');
                }
    			return false;
			});
      		$( ".sl_header a, .conShop, .sl-overlay" ).click(function() {
  				$( "body" ).removeClass('sl-open');
    			return false;
			});
            if (BUFFALO.quick_shop_enabled && quickShop.init(), $("body").on("change", "#cart_form input.quantity1", function() {
                    ajaxUpdateCart($(this).data("line-id"), $(this).val(), $(this).parents("#cart_form"))
                }), $("body").on("change", ".cart_content input.quantity", function() {
                    ajaxUpdateCart($(this).data("line-id"), $(this).val(), $(this).parents(".cart_content"))
                }), "ajax" === BUFFALO.cart_action && $("body").on("submit", ".product_form", function(e) {
                    e.preventDefault();
                    
                    var $addToCartForm = $(this),
                        $addToCartBtn = $addToCartForm.find(".add_to_cart");
                    return $.ajax({
                        url: "/cart/add.js",
                        dataType: "json",
                        cache: !1,
                        type: "post",
                        data: $addToCartForm.serialize(),
                        beforeSend: function() {
                            $addToCartBtn.attr("disabled", "disabled").addClass("disabled"), $addToCartBtn.find("span").removeClass("fadeInDown").addClass("animated zoomOut")
                        },
                        success: function(e) {
                          
                            $addToCartBtn.find(".checkmark").addClass("checkmark-active"), window.setTimeout(function() {
                                $addToCartBtn.removeAttr("disabled").removeClass("disabled"), $addToCartBtn.find(".checkmark").removeClass("checkmark-active"), $addToCartBtn.find("span").removeClass("zoomOut").addClass("fadeInDown")
                            }, 1e3), $.ajax({
                                url: "/cart.js",
                                dataType: "json",
                                cache: !1,
                                success: function(e) {
                                    refreshCart(e), $( "body" ).addClass('sl-open'), $("html").hasClass("remodal-is-locked") && $(".remodal-close").click(), $("#header").is(":visible") ? $("#header .cart_container").addClass("active_link") : $(".sticky_nav--stick").length ? $(".sticky_nav .cart_container").addClass("active_link") : $(".top_bar .cart_container").addClass("active_link")
                                }
                            })
                        },
                        error: function error(XMLHttpRequest) {
                            var response = eval("(" + XMLHttpRequest.responseText + ")");
                            response = response.description, $(".warning").remove();
//                             var warning = '<p class="warning animated bounceIn test">' + response.replace("All 1 ", "All ") + "</p>";
                          var warning = '<p class="warning animated bounceIn test">' + 'Please select an option' + "</p>";
                            $addToCartForm.after(warning), $addToCartBtn.removeAttr("disabled").removeClass("disabled"), $addToCartBtn.find("span").text(BUFFALO.translations.product_add_to_cart).removeClass("zoomOut").addClass("zoomIn")
                        }
                    }), !1
                }), "swatches" === BUFFALO.product_form_style) {
                if ($(".js-product_section").length) {
                    var $productForms = $(".js-product_section").find(".product_form");
                    $productForms.addClass("is-visible"), $productForms.each(function() {
                        var e = $(this).data("product"),
                            t = ".product-" + $(this).data("product-id") + " .js-product_section";
                        $(this).find(".swatch_options .swatch").length > 1 && Shopify.linkOptionSelectors(e, t)
                    })
                }
                $(".js-product_section").length > 1 && $("body").on("click", ".swatch-element", function() {
                    var e = $(this).data("value");
                    $(this).siblings('input[value="' + e.replace(/\"/g, '\\"') + '"]').prop("checked", !0).trigger("change");
                    var t = $(this).parents(".product_form").data("product"),
                        i = ".product-" + $(this).parents(".product_form").data("product-id") + " .js-product_section";
                    $(this).parents(".product_form").find(".swatch_options .swatch").length > 1 && Shopify.linkOptionSelectors(t, i)
                })
            }
        }), Shopify.updateOptionsInSelector = function(e, t) {
            switch (e) {
                case 0:
                    var i = "root",
                        o = $(t + " .single-option-selector:eq(0)");
                    break;
                case 1:
                    i = $(t + " .single-option-selector:eq(0)").val(), o = $(t + " .single-option-selector:eq(1)");
                    break;
                case 2:
                    i = $(t + " .single-option-selector:eq(0)").val();
                    i += " / " + $(t + " .single-option-selector:eq(1)").val();
                    o = $(t + " .single-option-selector:eq(2)")
            }
            var n = Shopify.optionsMap[i];
            $(t + ' .swatch[data-option-index="' + e + '"] .swatch-element').each(function() {
                -1 !== $.inArray($(this).attr("data-value"), n) ? $(this).removeClass("soldout").find(":radio").removeAttr("disabled", "disabled").removeAttr("checked") : $(this).addClass("soldout").find(":radio").removeAttr("checked").attr("disabled", "disabled")
            }), o.trigger("change")
        }, Shopify.linkOptionSelectors = function(e, t) {
            Shopify.optionsMap = {};
            for (var i = 0; i < e.variants.length; i++) {
                var o = e.variants[i];
                if (o.available) {
                    if (Shopify.optionsMap.root = Shopify.optionsMap.root || [], Shopify.optionsMap.root.push(o.option1), Shopify.optionsMap.root = Shopify.uniq(Shopify.optionsMap.root), e.options.length > 1) {
                        var n = o.option1;
                        Shopify.optionsMap[n] = Shopify.optionsMap[n] || [], Shopify.optionsMap[n].push(o.option2), Shopify.optionsMap[n] = Shopify.uniq(Shopify.optionsMap[n])
                    }
                    if (3 === e.options.length) {
                        n = o.option1 + " / " + o.option2;
                        Shopify.optionsMap[n] = Shopify.optionsMap[n] || [], Shopify.optionsMap[n].push(o.option3), Shopify.optionsMap[n] = Shopify.uniq(Shopify.optionsMap[n])
                    }
                }
            }
            Shopify.updateOptionsInSelector(0, t), e.options.length > 1 && Shopify.updateOptionsInSelector(1, t), 3 === e.options.length && Shopify.updateOptionsInSelector(2, t), $(t + " .single-option-selector:eq(0)").change(function() {
                return Shopify.updateOptionsInSelector(1, t), 3 === e.options.length && Shopify.updateOptionsInSelector(2, t), !0
            }), $(t + " .single-option-selector:eq(1)").change(function() {
                return 3 === e.options.length && Shopify.updateOptionsInSelector(2, t), !0
            })
        }, void 0 === Shopify) var Shopify = {};
  
  

  

    function PointerEventsPolyfill(e) {
        if (this.options = {
                selector: "*",
                mouseEvents: ["click", "dblclick", "mousedown", "mouseup"],
                usePolyfillIf: function() {
                    if ("Microsoft Internet Explorer" == navigator.appName && (null != navigator.userAgent.match(/MSIE ([0-9]{1,}[\.0-9]{0,})/) && 11 > parseFloat(RegExp.$1))) return !0;
                    return !1
                }
            }, e) {
            var t = this;
            $.each(e, function(e, i) {
                t.options[e] = i
            })
        }
        this.options.usePolyfillIf() && this.register_mouse_events()
    }
    Shopify.each = function(e, t) {
            for (var i = 0; i < e.length; i++) t(e[i], i)
        }, Shopify.map = function(e, t) {
            for (var i = [], o = 0; o < e.length; o++) i.push(t(e[o], o));
            return i
        }, Shopify.arrayIncludes = function(e, t) {
            for (var i = 0; i < e.length; i++)
                if (e[i] == t) return !0;
            return !1
        }, Shopify.uniq = function(e) {
            for (var t = [], i = 0; i < e.length; i++) Shopify.arrayIncludes(t, e[i]) || t.push(e[i]);
            return t
        }, Shopify.isDefined = function(e) {
            return void 0 !== e
        }, Shopify.getClass = function(e) {
            return Object.prototype.toString.call(e).slice(8, -1)
        }, Shopify.extend = function(e, t) {
            function i() {}
            i.prototype = t.prototype, e.prototype = new i, e.prototype.constructor = e, e.baseConstructor = t, e.superClass = t.prototype
        }, Shopify.locationSearch = function() {
            return window.location.search
        }, Shopify.locationHash = function() {
            return window.location.hash
        }, Shopify.replaceState = function(e) {
            window.history.replaceState({}, document.title, e)
        }, Shopify.urlParam = function(e) {
            var t = RegExp("[?&]" + e + "=([^&#]*)").exec(Shopify.locationSearch());
            return t && decodeURIComponent(t[1].replace(/\+/g, " "))
        }, Shopify.newState = function(e, t) {
            return (Shopify.urlParam(e) ? Shopify.locationSearch().replace(RegExp("(" + e + "=)[^&#]+"), "$1" + t) : "" === Shopify.locationSearch() ? "?" + e + "=" + t : Shopify.locationSearch() + "&" + e + "=" + t) + Shopify.locationHash()
        }, Shopify.setParam = function(e, t) {
            Shopify.replaceState(Shopify.newState(e, t))
        }, Shopify.Product = function(e) {
            Shopify.isDefined(e) && this.update(e)
        }, Shopify.Product.prototype.update = function(e) {
            for (var t in e) this[t] = e[t]
        }, Shopify.Product.prototype.optionNames = function() {
            return "Array" == Shopify.getClass(this.options) ? this.options : []
        }, Shopify.Product.prototype.optionValues = function(e) {
            if (!Shopify.isDefined(this.variants)) return null;
            var t = Shopify.map(this.variants, function(t) {
                var i = "option" + (e + 1);
                return void 0 == t[i] ? null : t[i]
            });
            return null == t[0] ? null : Shopify.uniq(t)
        }, Shopify.Product.prototype.getVariant = function(e) {
            var t = null;
            return e.length != this.options.length ? t : (Shopify.each(this.variants, function(i) {
                for (var o = !0, n = 0; n < e.length; n++) {
                    i["option" + (n + 1)] != e[n] && (o = !1)
                }
                return 1 == o ? void(t = i) : void 0
            }), t)
        }, Shopify.Product.prototype.getVariantById = function(e) {
            for (var t = 0; t < this.variants.length; t++) {
                var i = this.variants[t];
                if (e == i.id) return i
            }
            return null
        }, Shopify.money_format = "${{amount}}", Shopify.formatMoney = function(e, t) {
            function i(e, t) {
                return void 0 === e ? t : e
            }

            function o(e, t, o, n) {
                if (t = i(t, 2), o = i(o, ","), n = i(n, "."), isNaN(e) || null == e) return 0;
                var a = (e = (e / 100).toFixed(t)).split(".");
                return a[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + o) + (a[1] ? n + a[1] : "")
            }
            "string" == typeof e && (e = e.replace(".", ""));
            var n = "",
                a = /\{\{\s*(\w+)\s*\}\}/,
                r = t || this.money_format;
            switch (r.match(a)[1]) {
                case "amount":
                    n = o(e, 2);
                    break;
                case "amount_no_decimals":
                    n = o(e, 0);
                    break;
                case "amount_with_comma_separator":
                    n = o(e, 2, ".", ",");
                    break;
                case "amount_no_decimals_with_comma_separator":
                    n = o(e, 0, ".", ",")
            }
            return r.replace(a, n)
        }, Shopify.OptionSelectors = function(e, t) {
            return this.selectorDivClass = "selector-wrapper", this.selectorClass = "single-option-selector", this.variantIdFieldIdSuffix = "-variant-id", this.variantIdField = null, this.historyState = null, this.selectors = [], this.domIdPrefix = e, this.product = new Shopify.Product(t.product), this.onVariantSelected = Shopify.isDefined(t.onVariantSelected) ? t.onVariantSelected : function() {}, this.replaceSelector(e), this.initDropdown(), t.enableHistoryState && (this.historyState = new Shopify.OptionSelectors.HistoryState(this)), !0
        }, Shopify.OptionSelectors.prototype.initDropdown = function() {
            var e = {
                initialLoad: !0
            };
            if (!this.selectVariantFromDropdown(e)) {
                var t = this;
                setTimeout(function() {
                    t.selectVariantFromParams(e) || t.fireOnChangeForFirstDropdown.call(t, e)
                })
            }
        }, Shopify.OptionSelectors.prototype.fireOnChangeForFirstDropdown = function(e) {
            this.selectors[0].element.onchange(e)
        }, Shopify.OptionSelectors.prototype.selectVariantFromParamsOrDropdown = function(e) {
            this.selectVariantFromParams(e) || this.selectVariantFromDropdown(e)
        }, Shopify.OptionSelectors.prototype.replaceSelector = function(e) {
            var t = document.getElementById(e),
                i = t.parentNode;
            Shopify.each(this.buildSelectors(), function(e) {
                i.insertBefore(e, t), $(e).find("select").prepend($(t).find("[data-select-placeholder]").clone())
            }), t.style.display = "none", this.variantIdField = t
        }, Shopify.OptionSelectors.prototype.selectVariantFromDropdown = function(e) {
            var t = document.getElementById(this.domIdPrefix).querySelector("[selected]");
            if (t || (t = document.getElementById(this.domIdPrefix).querySelector('[selected="selected"]')), !t) return !1;
            var i = t.value;
            return this.selectVariant(i, e)
        }, Shopify.OptionSelectors.prototype.selectVariantFromParams = function(e) {
            var t = Shopify.urlParam("variant");
            return this.selectVariant(t, e)
        }, Shopify.OptionSelectors.prototype.selectVariant = function(e, t) {
            var i = this.product.getVariantById(e);
            if (null == i) return !1;
            for (var o = 0; o < this.selectors.length; o++) {
                var n = this.selectors[o].element,
                    a = i[n.getAttribute("data-option")];
                null != a && this.optionExistInSelect(n, a) && (n.value = a)
            }
            return "undefined" != typeof jQuery ? jQuery(this.selectors[0].element).trigger("change", t) : this.selectors[0].element.onchange(t), !0
        }, Shopify.OptionSelectors.prototype.optionExistInSelect = function(e, t) {
            for (var i = 0; i < e.options.length; i++)
                if (e.options[i].value == t) return !0
        }, Shopify.OptionSelectors.prototype.insertSelectors = function(e, t) {
            Shopify.isDefined(t) && this.setMessageElement(t), this.domIdPrefix = "product-" + this.product.id + "-variant-selector";
            var i = document.getElementById(e);
            Shopify.each(this.buildSelectors(), function(e) {
                i.appendChild(e)
            })
        }, Shopify.OptionSelectors.prototype.buildSelectors = function() {
            for (var e = 0; e < this.product.optionNames().length; e++) {
                var t = new Shopify.SingleOptionSelector(this, e, this.product.optionNames()[e], this.product.optionValues(e));
                t.element.disabled = !1, this.selectors.push(t)
            }
            var i = this.selectorDivClass,
                o = this.product.optionNames();
            return Shopify.map(this.selectors, function(e) {
                var t = document.createElement("div");
                if (t.setAttribute("class", i), o.length > 1) {
                    var n = document.createElement("label");
                    n.htmlFor = e.element.id, n.innerHTML = e.name, t.appendChild(n)
                }
                return t.appendChild(e.element), t
            })
        }, Shopify.OptionSelectors.prototype.selectedValues = function() {
            for (var e = [], t = 0; t < this.selectors.length; t++) {
                var i = this.selectors[t].element.value;
                e.push(i)
            }
            return e
        }, Shopify.OptionSelectors.prototype.updateSelectors = function(e, t) {
            var i = this.selectedValues(),
                o = this.product.getVariant(i);
            o ? (this.variantIdField.disabled = !1, this.variantIdField.value = o.id) : this.variantIdField.disabled = !0, this.onVariantSelected(o, this, t), null != this.historyState && this.historyState.onVariantChange(o, this, t)
        }, Shopify.OptionSelectorsFromDOM = function(e, t) {
            var i = t.optionNames || [],
                o = t.priceFieldExists || !0,
                n = t.delimiter || "/",
                a = this.createProductFromSelector(e, i, o, n);
            t.product = a, Shopify.OptionSelectorsFromDOM.baseConstructor.call(this, e, t)
        }, Shopify.extend(Shopify.OptionSelectorsFromDOM, Shopify.OptionSelectors), Shopify.OptionSelectorsFromDOM.prototype.createProductFromSelector = function(e, t, i, o) {
            if (!Shopify.isDefined(i)) i = !0;
            if (!Shopify.isDefined(o)) o = "/";
            var n = document.getElementById(e),
                a = n.childNodes,
                r = (n.parentNode, t.length),
                s = [];
            Shopify.each(a, function(e, n) {
                if (1 == e.nodeType && "option" == e.tagName.toLowerCase()) {
                    var a = e.innerHTML.split(new RegExp("\\s*\\" + o + "\\s*"));
                    0 == t.length && (r = a.length - (i ? 1 : 0));
                    var l = a.slice(0, r),
                        c = i ? a[r] : "",
                        d = (e.getAttribute("value"), {
                            available: !e.disabled,
                            id: parseFloat(e.value),
                            price: c,
                            option1: l[0],
                            option2: l[1],
                            option3: l[2]
                        });
                    s.push(d)
                }
            });
            var l = {
                variants: s
            };
            if (0 == t.length) {
                l.options = [];
                for (var c = 0; r > c; c++) l.options[c] = "option " + (c + 1)
            } else l.options = t;
            return l
        }, Shopify.SingleOptionSelector = function(e, t, i, o) {
            this.multiSelector = e, this.values = o, this.index = t, this.name = i, this.element = document.createElement("select");
            for (var n = 0; n < o.length; n++) {
                var a = document.createElement("option");
                a.value = o[n], a.innerHTML = o[n], this.element.appendChild(a)
            }
            return this.element.setAttribute("class", this.multiSelector.selectorClass), this.element.setAttribute("data-option", "option" + (t + 1)), this.element.id = e.domIdPrefix + "-option-" + t, this.element.onchange = function(i, o) {
                o = o || {}, e.updateSelectors(t, o)
            }, !0
        }, Shopify.Image = {
            preload: function(e, t) {
                for (var i = 0; i < e.length; i++) {
                    var o = e[i];
                    this.loadImage(this.getSizedImageUrl(o, t))
                }
            },
            loadImage: function(e) {
                (new Image).src = e
            },
            switchImage: function(e, t, i) {
                if (e && t) {
                    var o = this.imageSize(t.src),
                        n = this.getSizedImageUrl(e.src, o);
                    i ? i(n, e, t) : t.src = n
                }
            },
            imageSize: function(e) {
                var t = e.match(/_(1024x1024|2048x2048|pico|icon|thumb|small|compact|medium|large|grande)\./);
                return null != t ? t[1] : null
            },
            getSizedImageUrl: function(e, t) {
                if (null == t) return e;
                if ("master" == t) return this.removeProtocol(e);
                var i = e.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);
                if (null != i) {
                    var o = e.split(i[0]),
                        n = i[0];
                    return this.removeProtocol(o[0] + "_" + t + n)
                }
                return null
            },
            removeProtocol: function(e) {
                return e.replace(/http(s)?:/, "")
            }
        }, Shopify.OptionSelectors.HistoryState = function(e) {
            this.browserSupports() && this.register(e)
        }, Shopify.OptionSelectors.HistoryState.prototype.register = function(e) {
            window.addEventListener("popstate", function(t) {
                e.selectVariantFromParamsOrDropdown({
                    popStateCall: !0
                })
            })
        }, Shopify.OptionSelectors.HistoryState.prototype.onVariantChange = function(e, t, i) {
            this.browserSupports() && (!e || i.initialLoad || i.popStateCall || Shopify.setParam("variant", e.id))
        }, Shopify.OptionSelectors.HistoryState.prototype.browserSupports = function() {
            return window.history && window.history.replaceState
        },
        /*
         * jQuery offscreen plugin
         *
         * Copyright Cory LaViska for A Beautiful Site, LLC
         *
         * @license: http://opensource.org/licenses/MIT
         *
         */
        function(e) {
            e.extend(e.expr[":"], {
                "off-top": function(t) {
                    return e(t).offset().top < e(window).scrollTop()
                },
                "off-right": function(t) {
                    return e(t).offset().left + e(t).outerWidth() - e(window).scrollLeft() > e(window).width()
                },
                "off-bottom": function(t) {
                    return e(t).offset().top + e(t).outerHeight() - e(window).scrollTop() > e(window).height()
                },
                "off-left": function(t) {
                    return e(t).offset().left < e(window).scrollLeft()
                },
                "off-screen": function(t) {
                    return e(t).is(":off-top, :off-right, :off-bottom, :off-left")
                }
            })
        }(jQuery),
        /*!
          Zoom 1.7.15
          license: MIT
          http://www.jacklmoore.com/zoom
        */
        function(e) {
            var t = {
                url: !1,
                callback: !1,
                target: !1,
                duration: 120,
                on: "mouseover",
                touch: !0,
                onZoomIn: !1,
                onZoomOut: !1,
                magnify: 1
            };
            e.zoom = function(t, i, o, n) {
                var a, r, s, l, c, d, u, p = e(t),
                    h = p.css("position"),
                    f = e(i);
                return p.css("position", /(absolute|fixed)/.test(h) ? h : "relative"), p.css("overflow", "hidden"), o.style.width = o.style.height = "", e(o).addClass("zoomImg").css({
                    position: "absolute",
                    top: 0,
                    left: 0,
                    opacity: 0,
                    width: o.width * n,
                    height: o.height * n,
                    border: "none",
                    maxWidth: "none",
                    maxHeight: "none"
                }).appendTo(t), {
                    init: function() {
                        r = p.outerWidth(), a = p.outerHeight(), i === p[0] ? (l = r, s = a) : (l = f.outerWidth(), s = f.outerHeight()), c = (o.width - r) / l, d = (o.height - a) / s, u = f.offset()
                    },
                    move: function(e) {
                        var t = e.pageX - u.left,
                            i = e.pageY - u.top;
                        i = Math.max(Math.min(i, s), 0), t = Math.max(Math.min(t, l), 0), o.style.left = t * -c + "px", o.style.top = i * -d + "px"
                    }
                }
            }, e.fn.zoom = function(i) {
                return this.each(function() {
                    var o, n = e.extend({}, t, i || {}),
                        a = n.target || this,
                        r = this,
                        s = e(r),
                        l = e(a),
                        c = document.createElement("img"),
                        d = e(c),
                        u = "mousemove.zoom",
                        p = !1,
                        h = !1;
                    (n.url || ((o = s.find("img"))[0] && (n.url = o.data("src") || o.attr("src")), n.url)) && (! function() {
                        var e = l.css("position"),
                            t = l.css("overflow");
                        s.one("zoom.destroy", function() {
                            s.off(".zoom"), l.css("position", e), l.css("overflow", t), d.remove()
                        })
                    }(), c.onload = function() {
                        var t = e.zoom(a, r, c, n.magnify);

                        function i(i) {
                            t.init(), t.move(i), d.stop().fadeTo(e.support.opacity ? n.duration : 0, 1, !!e.isFunction(n.onZoomIn) && n.onZoomIn.call(c))
                        }

                        function o() {
                            d.stop().fadeTo(n.duration, 0, !!e.isFunction(n.onZoomOut) && n.onZoomOut.call(c))
                        }
                        "grab" === n.on ? s.on("mousedown.zoom", function(n) {
                            1 === n.which && (e(document).one("mouseup.zoom", function() {
                                o(), e(document).off(u, t.move)
                            }), i(n), e(document).on(u, t.move), n.preventDefault())
                        }) : "click" === n.on ? s.on("click.zoom", function(n) {
                            return p ? void 0 : (p = !0, i(n), e(document).on(u, t.move), e(document).one("click.zoom", function() {
                                o(), p = !1, e(document).off(u, t.move)
                            }), !1)
                        }) : "toggle" === n.on ? s.on("click.zoom", function(e) {
                            p ? o() : i(e), p = !p
                        }) : "mouseover" === n.on && (t.init(), s.on("mouseenter.zoom", i).on("mouseleave.zoom", o).on(u, t.move)), n.touch && s.on("touchstart.zoom", function(e) {
                            e.preventDefault(), h ? (h = !1, o()) : (h = !0, i(e.originalEvent.touches[0] || e.originalEvent.changedTouches[0]))
                        }).on("touchmove.zoom", function(e) {
                            e.preventDefault(), t.move(e.originalEvent.touches[0] || e.originalEvent.changedTouches[0])
                        }).on("touchend.zoom", function(e) {
                            e.preventDefault(), h && (h = !1, o())
                        }), e.isFunction(n.callback) && n.callback.call(c)
                    }, c.src = n.url)
                })
            }, e.fn.zoom.defaults = t
        }(window.jQuery),
        function() {
            function e(o) {
                if (!o) throw new Error("No options passed to Waypoint constructor");
                if (!o.element) throw new Error("No element option passed to Waypoint constructor");
                if (!o.handler) throw new Error("No handler option passed to Waypoint constructor");
                this.key = "waypoint-" + t, this.options = e.Adapter.extend({}, e.defaults, o), this.element = this.options.element, this.adapter = new e.Adapter(this.element), this.callback = o.handler, this.axis = this.options.horizontal ? "horizontal" : "vertical", this.enabled = this.options.enabled, this.triggerPoint = null, this.group = e.Group.findOrCreate({
                    name: this.options.group,
                    axis: this.axis
                }), this.context = e.Context.findOrCreateByElement(this.options.context), e.offsetAliases[this.options.offset] && (this.options.offset = e.offsetAliases[this.options.offset]), this.group.add(this), this.context.add(this), i[this.key] = this, t += 1
            }
            var t = 0,
                i = {};
            e.prototype.queueTrigger = function(e) {
                this.group.queueTrigger(this, e)
            }, e.prototype.trigger = function(e) {
                this.enabled && this.callback && this.callback.apply(this, e)
            }, e.prototype.destroy = function() {
                this.context.remove(this), this.group.remove(this), delete i[this.key]
            }, e.prototype.disable = function() {
                return this.enabled = !1, this
            }, e.prototype.enable = function() {
                return this.context.refresh(), this.enabled = !0, this
            }, e.prototype.next = function() {
                return this.group.next(this)
            }, e.prototype.previous = function() {
                return this.group.previous(this)
            }, e.invokeAll = function(e) {
                var t = [];
                for (var o in i) t.push(i[o]);
                for (var n = 0, a = t.length; a > n; n++) t[n][e]()
            }, e.destroyAll = function() {
                e.invokeAll("destroy")
            }, e.disableAll = function() {
                e.invokeAll("disable")
            }, e.enableAll = function() {
                e.invokeAll("enable")
            }, e.refreshAll = function() {
                e.Context.refreshAll()
            }, e.viewportHeight = function() {
                return window.innerHeight || document.documentElement.clientHeight
            }, e.viewportWidth = function() {
                return document.documentElement.clientWidth
            }, e.adapters = [], e.defaults = {
                context: window,
                continuous: !0,
                enabled: !0,
                group: "default",
                horizontal: !1,
                offset: 0
            }, e.offsetAliases = {
                "bottom-in-view": function() {
                    return this.context.innerHeight() - this.adapter.outerHeight()
                },
                "right-in-view": function() {
                    return this.context.innerWidth() - this.adapter.outerWidth()
                }
            }, window.Waypoint = e
        }(),
        function() {
            function e(e) {
                window.setTimeout(e, 1e3 / 60)
            }

            function t(e) {
                this.element = e, this.Adapter = n.Adapter, this.adapter = new this.Adapter(e), this.key = "waypoint-context-" + i, this.didScroll = !1, this.didResize = !1, this.oldScroll = {
                    x: this.adapter.scrollLeft(),
                    y: this.adapter.scrollTop()
                }, this.waypoints = {
                    vertical: {},
                    horizontal: {}
                }, e.waypointContextKey = this.key, o[e.waypointContextKey] = this, i += 1, this.createThrottledScrollHandler(), this.createThrottledResizeHandler()
            }
            var i = 0,
                o = {},
                n = window.Waypoint,
                a = window.onload;
            t.prototype.add = function(e) {
                var t = e.options.horizontal ? "horizontal" : "vertical";
                this.waypoints[t][e.key] = e, this.refresh()
            }, t.prototype.checkEmpty = function() {
                var e = this.Adapter.isEmptyObject(this.waypoints.horizontal),
                    t = this.Adapter.isEmptyObject(this.waypoints.vertical);
                e && t && (this.adapter.off(".waypoints"), delete o[this.key])
            }, t.prototype.createThrottledResizeHandler = function() {
                function e() {
                    t.handleResize(), t.didResize = !1
                }
                var t = this;
                this.adapter.on("resize.waypoints", function() {
                    t.didResize || (t.didResize = !0, n.requestAnimationFrame(e))
                })
            }, t.prototype.createThrottledScrollHandler = function() {
                function e() {
                    t.handleScroll(), t.didScroll = !1
                }
                var t = this;
                this.adapter.on("scroll.waypoints", function() {
                    (!t.didScroll || n.isTouch) && (t.didScroll = !0, n.requestAnimationFrame(e))
                })
            }, t.prototype.handleResize = function() {
                n.Context.refreshAll()
            }, t.prototype.handleScroll = function() {
                var e = {},
                    t = {
                        horizontal: {
                            newScroll: this.adapter.scrollLeft(),
                            oldScroll: this.oldScroll.x,
                            forward: "right",
                            backward: "left"
                        },
                        vertical: {
                            newScroll: this.adapter.scrollTop(),
                            oldScroll: this.oldScroll.y,
                            forward: "down",
                            backward: "up"
                        }
                    };
                for (var i in t) {
                    var o = t[i],
                        n = o.newScroll > o.oldScroll ? o.forward : o.backward;
                    for (var a in this.waypoints[i]) {
                        var r = this.waypoints[i][a],
                            s = o.oldScroll < r.triggerPoint,
                            l = o.newScroll >= r.triggerPoint;
                        (s && l || !s && !l) && (r.queueTrigger(n), e[r.group.id] = r.group)
                    }
                }
                for (var c in e) e[c].flushTriggers();
                this.oldScroll = {
                    x: t.horizontal.newScroll,
                    y: t.vertical.newScroll
                }
            }, t.prototype.innerHeight = function() {
                return this.element == this.element.window ? n.viewportHeight() : this.adapter.innerHeight()
            }, t.prototype.remove = function(e) {
                delete this.waypoints[e.axis][e.key], this.checkEmpty()
            }, t.prototype.innerWidth = function() {
                return this.element == this.element.window ? n.viewportWidth() : this.adapter.innerWidth()
            }, t.prototype.destroy = function() {
                var e = [];
                for (var t in this.waypoints)
                    for (var i in this.waypoints[t]) e.push(this.waypoints[t][i]);
                for (var o = 0, n = e.length; n > o; o++) e[o].destroy()
            }, t.prototype.refresh = function() {
                var e, t = this.element == this.element.window,
                    i = t ? void 0 : this.adapter.offset(),
                    o = {};
                for (var a in this.handleScroll(), e = {
                        horizontal: {
                            contextOffset: t ? 0 : i.left,
                            contextScroll: t ? 0 : this.oldScroll.x,
                            contextDimension: this.innerWidth(),
                            oldScroll: this.oldScroll.x,
                            forward: "right",
                            backward: "left",
                            offsetProp: "left"
                        },
                        vertical: {
                            contextOffset: t ? 0 : i.top,
                            contextScroll: t ? 0 : this.oldScroll.y,
                            contextDimension: this.innerHeight(),
                            oldScroll: this.oldScroll.y,
                            forward: "down",
                            backward: "up",
                            offsetProp: "top"
                        }
                    }) {
                    var r = e[a];
                    for (var s in this.waypoints[a]) {
                        var l, c, d, u, p = this.waypoints[a][s],
                            h = p.options.offset,
                            f = p.triggerPoint,
                            m = 0,
                            g = null == f;
                        p.element !== p.element.window && (m = p.adapter.offset()[r.offsetProp]), "function" == typeof h ? h = h.apply(p) : "string" == typeof h && (h = parseFloat(h), p.options.offset.indexOf("%") > -1 && (h = Math.ceil(r.contextDimension * h / 100))), l = r.contextScroll - r.contextOffset, p.triggerPoint = m + l - h, c = f < r.oldScroll, d = p.triggerPoint >= r.oldScroll, u = !c && !d, !g && (c && d) ? (p.queueTrigger(r.backward), o[p.group.id] = p.group) : !g && u ? (p.queueTrigger(r.forward), o[p.group.id] = p.group) : g && r.oldScroll >= p.triggerPoint && (p.queueTrigger(r.forward), o[p.group.id] = p.group)
                    }
                }
                return n.requestAnimationFrame(function() {
                    for (var e in o) o[e].flushTriggers()
                }), this
            }, t.findOrCreateByElement = function(e) {
                return t.findByElement(e) || new t(e)
            }, t.refreshAll = function() {
                for (var e in o) o[e].refresh()
            }, t.findByElement = function(e) {
                return o[e.waypointContextKey]
            }, window.onload = function() {
                a && a(), t.refreshAll()
            }, n.requestAnimationFrame = function(t) {
                (window.requestAnimationFrame || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame || e).call(window, t)
            }, n.Context = t
        }(),
        function() {
            function e(e, t) {
                return e.triggerPoint - t.triggerPoint
            }

            function t(e, t) {
                return t.triggerPoint - e.triggerPoint
            }

            function i(e) {
                this.name = e.name, this.axis = e.axis, this.id = this.name + "-" + this.axis, this.waypoints = [], this.clearTriggerQueues(), o[this.axis][this.name] = this
            }
            var o = {
                    vertical: {},
                    horizontal: {}
                },
                n = window.Waypoint;
            i.prototype.add = function(e) {
                this.waypoints.push(e)
            }, i.prototype.clearTriggerQueues = function() {
                this.triggerQueues = {
                    up: [],
                    down: [],
                    left: [],
                    right: []
                }
            }, i.prototype.flushTriggers = function() {
                for (var i in this.triggerQueues) {
                    var o = this.triggerQueues[i],
                        n = "up" === i || "left" === i;
                    o.sort(n ? t : e);
                    for (var a = 0, r = o.length; r > a; a += 1) {
                        var s = o[a];
                        (s.options.continuous || a === o.length - 1) && s.trigger([i])
                    }
                }
                this.clearTriggerQueues()
            }, i.prototype.next = function(t) {
                this.waypoints.sort(e);
                var i = n.Adapter.inArray(t, this.waypoints);
                return i === this.waypoints.length - 1 ? null : this.waypoints[i + 1]
            }, i.prototype.previous = function(t) {
                this.waypoints.sort(e);
                var i = n.Adapter.inArray(t, this.waypoints);
                return i ? this.waypoints[i - 1] : null
            }, i.prototype.queueTrigger = function(e, t) {
                this.triggerQueues[t].push(e)
            }, i.prototype.remove = function(e) {
                var t = n.Adapter.inArray(e, this.waypoints);
                t > -1 && this.waypoints.splice(t, 1)
            }, i.prototype.first = function() {
                return this.waypoints[0]
            }, i.prototype.last = function() {
                return this.waypoints[this.waypoints.length - 1]
            }, i.findOrCreate = function(e) {
                return o[e.axis][e.name] || new i(e)
            }, n.Group = i
        }(),
        function() {
            function e(e) {
                this.$element = t(e)
            }
            var t = window.jQuery,
                i = window.Waypoint;
            t.each(["innerHeight", "innerWidth", "off", "offset", "on", "outerHeight", "outerWidth", "scrollLeft", "scrollTop"], function(t, i) {
                e.prototype[i] = function() {
                    var e = Array.prototype.slice.call(arguments);
                    return this.$element[i].apply(this.$element, e)
                }
            }), t.each(["extend", "inArray", "isEmptyObject"], function(i, o) {
                e[o] = t[o]
            }), i.adapters.push({
                name: "jquery",
                Adapter: e
            }), i.Adapter = e
        }(),
        function() {
            function e(e) {
                return function() {
                    var i = [],
                        o = arguments[0];
                    return e.isFunction(arguments[0]) && ((o = e.extend({}, arguments[1])).handler = arguments[0]), this.each(function() {
                        var n = e.extend({}, o, {
                            element: this
                        });
                        "string" == typeof n.context && (n.context = e(this).closest(n.context)[0]), i.push(new t(n))
                    }), i
                }
            }
            var t = window.Waypoint;
            window.jQuery && (window.jQuery.fn.waypoint = e(window.jQuery)), window.Zepto && (window.Zepto.fn.waypoint = e(window.Zepto))
        }(),
        function() {
            function e(o) {
                this.options = t.extend({}, e.defaults, o), this.container = this.options.element, "auto" !== this.options.container && (this.container = this.options.container), this.$container = t(this.container), this.$more = t(this.options.more), this.$more.length && (this.setupHandler(), this.waypoint = new i(this.options))
            }
            var t = window.jQuery,
                i = window.Waypoint;
            e.prototype.setupHandler = function() {
                this.options.handler = t.proxy(function() {
                    this.options.onBeforePageLoad(), this.destroy(), this.$container.addClass(this.options.loadingClass), t.get(t(this.options.more).attr("href"), t.proxy(function(e) {
                        var o = t(t.parseHTML(e)),
                            n = o.find(this.options.more),
                            a = o.find(this.options.items);
                        a.length || (a = o.filter(this.options.items)), this.$container.append(a), this.$container.removeClass(this.options.loadingClass), n.length || (n = o.filter(this.options.more)), n.length ? (this.$more.replaceWith(n), this.$more = n, this.waypoint = new i(this.options)) : this.$more.remove(), this.options.onAfterPageLoad(a)
                    }, this))
                }, this)
            }, e.prototype.destroy = function() {
                this.waypoint && this.waypoint.destroy()
            }, e.defaults = {
                container: "auto",
                items: ".infinite-item",
                more: ".infinite-more-link",
                offset: "bottom-in-view",
                loadingClass: "infinite-loading",
                onBeforePageLoad: t.noop,
                onAfterPageLoad: t.noop
            }, i.Infinite = e
        }(),
        function(e) {
            e.fn.mediaWrapper = function(t) {
                var i = e.extend({
                    intrinsic: !0,
                    baseWidth: 16,
                    baseHeight: 9
                }, t);
                return this.each(function() {
                    var t;
                    t = 1 == i.intrinsic && "" !== e(this).attr("width") && "" !== e(this).attr("height") ? e(this).attr("height") / e(this).attr("width") * 100 : i.baseHeight / i.baseWidth * 100, e(this).wrap('<div class="mediaWrapper" style="position: relative; width: 100%; height: 0; padding: ' + t + '% 0 0 0; " />').css({
                        position: "absolute",
                        width: "100%",
                        height: "100%",
                        top: "0",
                        left: "0"
                    })
                })
            }
        }(jQuery), PointerEventsPolyfill.initialize = function(e) {
            return null == PointerEventsPolyfill.singleton && (PointerEventsPolyfill.singleton = new PointerEventsPolyfill(e)), PointerEventsPolyfill.singleton
        }, PointerEventsPolyfill.prototype.register_mouse_events = function() {
            $(document).on(this.options.mouseEvents.join(" "), this.options.selector, function(e) {
                if ("none" == $(this).css("pointer-events")) {
                    var t = $(this).css("display");
                    $(this).css("display", "none");
                    var i = document.elementFromPoint(e.clientX, e.clientY);
                    return t ? $(this).css("display", t) : $(this).css("display", ""), e.target = i, $(i).trigger(e), !1
                }
                return !0
            })
        },
        function(e, t, i) {
            function o(e, t) {
                return _typeof(e) === t
            }

            function n() {
                return "function" != typeof t.createElement ? t.createElement(arguments[0]) : u ? t.createElementNS.call(t, "http://www.w3.org/2000/svg", arguments[0]) : t.createElement.apply(t, arguments)
            }

            function a() {
                var e = t.body;
                return e || ((e = n(u ? "svg" : "body")).fake = !0), e
            }
            var r = [],
                s = [],
                l = {
                    _version: "3.3.1",
                    _config: {
                        classPrefix: "",
                        enableClasses: !0,
                        enableJSClass: !0,
                        usePrefixes: !0
                    },
                    _q: [],
                    on: function(e, t) {
                        var i = this;
                        setTimeout(function() {
                            t(i[e])
                        }, 0)
                    },
                    addTest: function(e, t, i) {
                        s.push({
                            name: e,
                            fn: t,
                            options: i
                        })
                    },
                    addAsyncTest: function(e) {
                        s.push({
                            name: null,
                            fn: e
                        })
                    }
                },
                c = function() {};
            c.prototype = l, c = new c;
            var d = t.documentElement,
                u = "svg" === d.nodeName.toLowerCase(),
                p = l._config.usePrefixes ? " -webkit- -moz- -o- -ms- ".split(" ") : ["", ""];
            l._prefixes = p;
            var h = l.testStyles = function(e, i, o, r) {
                var s, l, c, u, p = "modernizr",
                    h = n("div"),
                    f = a();
                if (parseInt(o, 10))
                    for (; o--;)(c = n("div")).id = r ? r[o] : p + (o + 1), h.appendChild(c);
                return (s = n("style")).type = "text/css", s.id = "s" + p, (f.fake ? f : h).appendChild(s), f.appendChild(h), s.styleSheet ? s.styleSheet.cssText = e : s.appendChild(t.createTextNode(e)), h.id = p, f.fake && (f.style.background = "", f.style.overflow = "hidden", u = d.style.overflow, d.style.overflow = "hidden", d.appendChild(f)), l = i(h, e), f.fake ? (f.parentNode.removeChild(f), d.style.overflow = u, d.offsetHeight) : h.parentNode.removeChild(h), !!l
            };
            c.addTest("touchevents", function() {
                    var i;
                    if ("ontouchstart" in e || e.DocumentTouch && t instanceof DocumentTouch) i = !0;
                    else {
                        var o = ["@media (", p.join("touch-enabled),("), "heartz", ")", "{#modernizr{top:9px;position:absolute}}"].join("");
                        h(o, function(e) {
                            i = 9 === e.offsetTop
                        })
                    }
                    return i
                }),
                function() {
                    var e, t, i, n, a, l;
                    for (var d in s)
                        if (s.hasOwnProperty(d)) {
                            if (e = [], (t = s[d]).name && (e.push(t.name.toLowerCase()), t.options && t.options.aliases && t.options.aliases.length))
                                for (i = 0; i < t.options.aliases.length; i++) e.push(t.options.aliases[i].toLowerCase());
                            for (n = o(t.fn, "function") ? t.fn() : t.fn, a = 0; a < e.length; a++) 1 === (l = e[a].split(".")).length ? c[l[0]] = n : (!c[l[0]] || c[l[0]] instanceof Boolean || (c[l[0]] = new Boolean(c[l[0]])), c[l[0]][l[1]] = n), r.push((n ? "" : "no-") + l.join("-"))
                        }
                }(),
                function(e) {
                    var t = d.className,
                        i = c._config.classPrefix || "";
                    if (u && (t = t.baseVal), c._config.enableJSClass) {
                        var o = new RegExp("(^|\\s)" + i + "no-js(\\s|$)");
                        t = t.replace(o, "$1" + i + "js$2")
                    }
                    c._config.enableClasses && (t += " " + i + e.join(" " + i), u ? d.className.baseVal = t : d.className = t)
                }(r), delete l.addTest, delete l.addAsyncTest;
            for (var f = 0; f < c._q.length; f++) c._q[f]();
            e.Modernizr = c
        }(window, document),
        function() {
            var e = function() {
                function e(e) {
                    return decodeURIComponent(e.replace(/\+/g, " "))
                }

                function t(e, t) {
                    var i = e.charAt(0),
                        o = t.split(i);
                    return i === e ? o : o[(e = parseInt(e.substring(1), 10)) < 0 ? o.length + e : e - 1]
                }

                function i(t, i) {
                    for (var o = t.charAt(0), n = i.split("&"), a = [], r = {}, s = [], l = t.substring(1), c = 0, d = n.length; c < d; c++)
                        if ((a = n[c].match(/(.*?)=(.*)/)) || (a = [n[c], n[c], ""]), "" !== a[1].replace(/\s/g, "")) {
                            if (a[2] = e(a[2] || ""), l === a[1]) return a[2];
                            (s = a[1].match(/(.*)\[([0-9]+)\]/)) ? (r[s[1]] = r[s[1]] || [], r[s[1]][s[2]] = a[2]) : r[a[1]] = a[2]
                        }
                    return o === t ? r : r[l]
                }
                return function(e, o) {
                    var n, a = {};
                    if ("tld?" !== e) {
                        if (o = o || window.location.toString(), !e) return o;
                        if (e = e.toString(), n = o.match(/^mailto:([^\/].+)/)) a.protocol = "mailto", a.email = n[1];
                        else {
                            if ((n = o.match(/(.*?)\/#\!(.*)/)) && (o = n[1] + n[2]), (n = o.match(/(.*?)#(.*)/)) && (a.hash = n[2], o = n[1]), a.hash && e.match(/^#/)) return i(e, a.hash);
                            if ((n = o.match(/(.*?)\?(.*)/)) && (a.query = n[2], o = n[1]), a.query && e.match(/^\?/)) return i(e, a.query);
                            if ((n = o.match(/(.*?)\:?\/\/(.*)/)) && (a.protocol = n[1].toLowerCase(), o = n[2]), (n = o.match(/(.*?)(\/.*)/)) && (a.path = n[2], o = n[1]), a.path = (a.path || "").replace(/^([^\/])/, "/$1"), e.match(/^[\-0-9]+$/) && (e = e.replace(/^([^\/])/, "/$1")), e.match(/^\//)) return t(e, a.path.substring(1));
                            if ((n = t("/-1", a.path.substring(1))) && (n = n.match(/(.*?)\.(.*)/)) && (a.file = n[0], a.filename = n[1], a.fileext = n[2]), (n = o.match(/(.*)\:([0-9]+)$/)) && (a.port = n[2], o = n[1]), (n = o.match(/(.*?)@(.*)/)) && (a.auth = n[1], o = n[2]), a.auth && (n = a.auth.match(/(.*)\:(.*)/), a.user = n ? n[1] : a.auth, a.pass = n ? n[2] : void 0), a.hostname = o.toLowerCase(), "." === e.charAt(0)) return t(e, a.hostname);
                            a.port = a.port || ("https" === a.protocol ? "443" : "80"), a.protocol = a.protocol || ("443" === a.port ? "https" : "http")
                        }
                        return e in a ? a[e] : "{}" === e ? a : void 0
                    }
                }
            }();
            "function" == typeof window.define && window.define.amd ? window.define("js-url", [], function() {
                return e
            }) : (void 0 !== window.jQuery && window.jQuery.extend({
                url: function(e, t) {
                    return window.url(e, t)
                }
            }), window.url = e)
        }();
    var social = {
            twitter: function() {
                window.twttr || (window.twttr = function(e, t, i) {
                    var o, n, a = e.getElementsByTagName(t)[0];
                    if (!e.getElementById(i)) return (n = e.createElement(t)).id = i, n.src = "https://platform.twitter.com/widgets.js", a.parentNode.insertBefore(n, a), window.twttr || (o = {
                        _e: [],
                        ready: function(e) {
                            o._e.push(e)
                        }
                    })
                }(document, "script", "twitter-wjs")), window.twttr && window.twttr.ready(function(e) {
                    e.widgets.load(document.getElementById("twitter-timeline"))
                })
            },
            unload: function() {}
        },
        instagram = {
            loadContent: function(e) {
                if (e.clientID) {
                    var t = "https://api.instagram.com/v1/users/self/media/recent/?access_token=" + e.clientID;
                    $.ajax({
                        type: "GET",
                        url: t,
                        dataType: "jsonp",
                        success: function(t) {
                            if (200 === t.meta.code && t.data.length) {
                                t = t.data;
                                var i = 0;
                                e.el.empty();
                                for (var o = 0; o < t.length; o++) {
                                    var n, a = t[o],
                                        r = a.images.low_resolution.url;
                                    if (!a.images.low_resolution.url.indexOf("null") > -1 && (n = '<div class="il-photo__img instagram__bg" style="background-image:url(' + r + ')" data-filter="' + a.filter + '" /></div>', n = '<a href="' + a.link + '" target="_blank" class="instagram__link">' + n + "</a>"), a.videos && (n = '<div class="instagram__video instagram__bg" style="background-image:url(' + r + ')" data-filter="' + a.filter + '" /></div>', n = '<a href="' + a.link + '" target="_blank" class="instagram__link instagram__video-link">' + n + "</a>"), n && (n = '<div class="four columns instagram__item">' + n + "</div>"), "" !== n && (e.el.append(n), i++), i == e.limit) break
                                }
                            }
                        },
                        error: function() {}
                    })
                }
            }
        };
    $(".social-feeds-wrap").each(function(e, t) {
        social.twitter();
        var i = $(this).find(".js-instafeed");
        instagram.loadContent({
            el: i,
            clientID: i.data("client-id"),
            limit: i.data("count")
        })
    }), $(document).on("shopify:block:select", function(e) {
        var t = e.detail.blockId,
            i = $("#shopify-section-" + e.detail.sectionId);
        (i.hasClass("slideshow-section") || i.hasClass("testimonial-section")) && sliderBlock.select(t, i), utils.resizeActionButtons()
    }), $(document).on("shopify:block:deselect", function(e) {
        var t = $("#shopify-section-" + e.detail.sectionId);
        (t.hasClass("slideshow-section") || t.hasClass("testimonial-section")) && sliderBlock.deselect(t)
    }), $(document).on("shopify:section:reorder", function(e) {
        utils.pageBannerCheck()
    }), $(document).on("shopify:section:load", function(e) {
        var t = $("#shopify-section-" + e.detail.sectionId);
        utils.pageBannerCheck(), BUFFALO.newsletter_popup && newsletter_popup.init(), t.hasClass("social-feeds-section") && $(".social-feeds-wrap").each(function(e, t) {
            social.twitter();
            var i = $(this).find(".js-instafeed");
            instagram.loadContent({
                el: i,
                clientID: i.data("client-id"),
                limit: i.data("count")
            })
        }), t.hasClass("faq-section") && faqAccordion.init(), t.hasClass("cart-section") && cart.init(), t.hasClass("featured-promotions-section") && featuredPromotions.init(), t.hasClass("slideshow-section") && slideshow.init(), t.hasClass("testimonial-section") && testimonial.init(), t.hasClass("image-gallery-section") && gallery.init(), t.hasClass("featured-products-section") && (productPage.initializeQuantityBox(), productPage.init()), t.hasClass("featured-collection-section") && featuredCollectionSection.init(), t.hasClass("video-section") && videoSection.init(), t.hasClass("recently-viewed") && recentlyViewed.init(".js-recently-viewed"), t.hasClass("product-template") && (productPage.init(), productPage.relatedProducts(), recentlyViewed.init()), t.hasClass("article-template-section") && -1 != window.location.pathname.indexOf("/comments") && $("html,body").animate({
            scrollTop: $("#new-comment").offset().top - 140
        }, "slow"), t.hasClass("collection-template-section") && collectionSidebarFilter.init(), t.hasClass("search-template-section") && collection.init(), t.hasClass("header-section") && (header.init(), header.loadMegaMenu()), t.hasClass("mega-menu-section") && header.loadMegaMenu(), t.hasClass("page-details-section") && (featuredCollectionSection.init(), videoSection.init())
    }), $(document).on("shopify:section:unload", function(e) {
        var t = $(e.target),
            i = $("#shopify-section-" + e.detail.sectionId);
        i.hasClass("header-section") && (header.unload(t), header.unloadMegaMenu()), i.hasClass("slideshow-section") && slideshow.unload(t), i.hasClass("testimonial-section") && testimonial.unload(t), i.hasClass("video-section") && videoSection.unload(t), i.hasClass("product-template") && productPage.unload(t), i.hasClass("mega-menu-section") && header.unloadMegaMenu(), i.hasClass("page-details-section") && videoSection.unload(t)
    }), $(document).on("shopify:section:select", function(e) {
        var t = $("#shopify-section-" + e.detail.sectionId);
        if (t.hasClass("social-feeds-section") && $(".social-feeds-wrap").each(function(e, t) {
                social.twitter()
            }), t.hasClass("mega-menu-section")) {
            var i = $(".header ." + e.detail.sectionId).data("dropdown");
            setTimeout(function() {
                $('a.mega-menu-parent[data-dropdown-rel="' + i + '"]').trigger("mouseenter"), $('a.mega-menu-parent[data-dropdown-rel="' + i + '"]').parents("header").addClass("editor-hover--true"), header.removeDataAttributes(".header .mega-menu.dropdown_container .dropdown_column")
            }, 10)
        }
        t.hasClass("featured-collection-section") && (featuredCollectionSection.unload(t), featuredCollectionSection.init()), utils.pageBannerCheck();
        var o = document.createEvent("UIEvents");
        o.initUIEvent("resize", !0, !1, window, 0), window.dispatchEvent(o)
    }), $(document).on("shopify:section:deselect", function(e) {
        if ($("#shopify-section-" + e.detail.sectionId).hasClass("mega-menu-section")) {
            var t = $(".header ." + e.detail.sectionId).data("dropdown");
            $('a.mega-menu-parent[data-dropdown-rel="' + t + '"]').trigger("mouseout"), $('a.mega-menu-parent[data-dropdown-rel="' + t + '"]').parents("header").removeClass("editor-hover--true")
        }
    })
}, function(e, t, i) {
    i(2), e.exports = i(7)
}, , , , function(e, t) {}]);